var _style, _path, _defs, _rect, _rect2, _path2, _g, _circle, _g2, _circle2, _g3, _circle3, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _defs2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _g4, _g5, _polygon2, _path13, _path14, _path15, _path16, _path17, _polygon3, _polygon4, _g6, _g7, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path26, _defs3, _rect8, _rect9, _path27, _g8, _circle10, _g9, _circle11, _g10, _circle12, _path28, _rect10, _rect11, _rect12, _rect13, _rect14, _defs4, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon5, _path37, _g11, _g12, _polygon6, _path38, _path39, _path40, _path41, _path42, _polygon7, _polygon8, _g13, _g14, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 539",
    style: {
      enableBackground: "new 0 0 505 539"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F2F8FF;}\r\n\t.st1{clip-path:url(#SVGID_00000039120764443278782210000000448227998608703672_);}\r\n\t.st2{fill:#D6EAFF;}\r\n\t.st3{clip-path:url(#SVGID_00000039120764443278782210000000448227998608703672_);fill:#D6EAFF;}\r\n\t.st4{clip-path:url(#SVGID_00000039120764443278782210000000448227998608703672_);fill:#BCD9F7;}\r\n\t.st5{clip-path:url(#SVGID_00000039120764443278782210000000448227998608703672_);fill:#9CC3ED;}\r\n\t.st6{fill:url(#SVGID_00000183247637094036726110000014149228191570500755_);}\r\n\t.st7{fill:url(#SVGID_00000018917838466901519000000003971737289991881878_);}\r\n\t.st8{fill:url(#SVGID_00000116225221215986171520000000230563605690709946_);}\r\n\t.st9{fill:url(#SVGID_00000167370364116194979920000006730940057325908636_);}\r\n\t.st10{fill:url(#SVGID_00000174568416652394239430000002862726996875120799_);}\r\n\t.st11{fill:url(#SVGID_00000163767280247339457790000002418422037695285434_);}\r\n\t.st12{fill:url(#SVGID_00000079485156753079673410000000001366908877275299_);}\r\n\t.st13{fill:url(#SVGID_00000111184649511693186350000014814921357588973475_);}\r\n\t.st14{fill:url(#SVGID_00000007411516109660131640000018060920606787126703_);}\r\n\t.st15{fill:#BCD9F7;}\r\n\t.st16{clip-path:url(#SVGID_00000039120764443278782210000000448227998608703672_);fill:#95BBE3;}\r\n\t.st17{fill:#9CC3ED;}\r\n\t.st18{clip-path:url(#SVGID_00000039120764443278782210000000448227998608703672_);fill:#ACCFF2;}\r\n\t.st19{fill:#FFFFFF;}\r\n\t.st20{fill:#D6F1FF;}\r\n\t.st21{fill:#C1E4F5;}\r\n\t\r\n\t\t.st22{clip-path:url(#SVGID_00000028291667777063545670000002050699613371243659_);fill:url(#SVGID_00000177473221735198534670000013998773295393705095_);}\r\n\t\r\n\t\t.st23{clip-path:url(#SVGID_00000028291667777063545670000002050699613371243659_);fill:url(#SVGID_00000086653312396144262410000008814370917860097966_);}\r\n\t.st24{fill:url(#SVGID_00000042734291918628129160000005979902274194469003_);}\r\n\t.st25{fill:url(#SVGID_00000126281312394415106390000012898001614185063865_);}\r\n\t.st26{fill:url(#SVGID_00000088835296173494446440000012122057347740423046_);}\r\n\t.st27{fill:url(#SVGID_00000020395559185179419340000011299612108327668097_);}\r\n\t.st28{fill:url(#SVGID_00000013191814743178421260000012988890156756015250_);}\r\n\t.st29{fill:url(#SVGID_00000046326501078154996700000004822818262757342109_);}\r\n\t.st30{fill:url(#SVGID_00000097470027744775027040000012847884516992606893_);}\r\n\t.st31{fill:url(#SVGID_00000109734061993788636680000000001297258908665737_);}\r\n\t.st32{fill:url(#SVGID_00000085234274316497079910000008848449845564695970_);}\r\n\t.st33{fill:url(#SVGID_00000079454035264874576270000002336108965147889823_);}\r\n\t.st34{fill:url(#SVGID_00000013895072716457484930000013863003603957921725_);}\r\n\t.st35{fill:url(#SVGID_00000008119274994948624560000003596347442700561051_);}\r\n\t.st36{fill:url(#SVGID_00000117662043621070899490000015190948936634628485_);}\r\n\t.st37{fill:url(#SVGID_00000078023303774558644690000008169478940828974251_);}\r\n\t.st38{fill:url(#SVGID_00000037688595854821026760000000063887549111091609_);}\r\n\t.st39{fill:url(#SVGID_00000010993271938005293730000000015095335298984601_);}\r\n\t.st40{fill:url(#SVGID_00000083075492170690017810000014855929694412801176_);}\r\n\t.st41{fill:url(#SVGID_00000035531370670686640960000018253058396847047318_);}\r\n\t.st42{fill:url(#SVGID_00000172411673707815368750000016487324547306939573_);}\r\n\t.st43{fill:url(#SVGID_00000079447206605047893560000012822114388713551536_);}\r\n\t.st44{fill:url(#SVGID_00000152234588154787052770000009897607095660161941_);}\r\n\t.st45{fill:url(#SVGID_00000111181030733990784190000013317131552701535363_);}\r\n\t.st46{fill:url(#SVGID_00000147187290472167946060000004754446841950379955_);}\r\n\t.st47{fill:url(#SVGID_00000144328051595080722740000014489474920187818134_);}\r\n\t.st48{fill:url(#SVGID_00000121971040777489763550000011365429571942344357_);}\r\n\t.st49{fill:url(#SVGID_00000166651277553795843360000003486331542895726767_);}\r\n\t.st50{fill:url(#SVGID_00000067918850455259418510000000694231744980192443_);}\r\n\t.st51{fill:url(#SVGID_00000052800122240527267960000013593256734605951934_);}\r\n\t.st52{fill:url(#SVGID_00000059305594059984804810000018052417583944537744_);}\r\n\t.st53{fill:url(#SVGID_00000103982072283381210960000001099623888338691249_);}\r\n\t.st54{fill:url(#SVGID_00000164489073186945583540000017914474701747839393_);}\r\n\t.st55{fill:url(#SVGID_00000155866116784869972640000008677955045686882700_);}\r\n\t.st56{fill:url(#SVGID_00000070819388034208006050000017582099700142965665_);}\r\n\t.st57{fill:url(#SVGID_00000153669991155556190480000010045507166104964746_);}\r\n\t.st58{fill:url(#SVGID_00000013874330423722985160000000378344187853583541_);}\r\n\t.st59{fill:url(#SVGID_00000089539519915268857280000005208451710557823151_);}\r\n\t.st60{fill:#FFCFBE;}\r\n\t.st61{fill:url(#SVGID_00000085931510024012263080000002799165231348482464_);}\r\n\t.st62{fill:url(#SVGID_00000052792909623074103340000004849463285124009635_);}\r\n\t.st63{fill:url(#SVGID_00000150808735423426020540000014760124958115431319_);}\r\n\t.st64{fill:url(#SVGID_00000146493421855185722120000017844791116403771297_);}\r\n\t.st65{fill:url(#SVGID_00000067954092451895151470000014825044351011677352_);}\r\n\t.st66{fill:url(#SVGID_00000109023156084547578520000013233893485601363095_);}\r\n\t.st67{fill:#95BBE3;}\r\n\t.st68{fill:url(#SVGID_00000076588870996628535640000004129434267275375028_);}\r\n\t.st69{fill:url(#SVGID_00000081613909007134364470000002378883653192609165_);}\r\n\t.st70{fill:url(#SVGID_00000082348567506652017820000014853831390356485012_);}\r\n\t.st71{fill:url(#SVGID_00000183250814957514779550000016650582987528695223_);}\r\n\t.st72{fill:url(#SVGID_00000089546274573201899110000010426043166063605894_);}\r\n\t.st73{fill:url(#SVGID_00000062876221738203474830000004179059673240317346_);}\r\n\t.st74{fill:#EDEDED;}\r\n\t.st75{fill:url(#SVGID_00000103963124112931611530000014490470353641405839_);}\r\n\t.st76{fill:url(#SVGID_00000022518931816142944620000002535555526413408667_);}\r\n\t.st77{fill:url(#SVGID_00000098941004739650176410000007413137356091579557_);}\r\n\t.st78{fill:url(#SVGID_00000000191448963340922860000007168150952788880785_);}\r\n\t.st79{fill:url(#SVGID_00000132066617792568919060000007344099905933383589_);}\r\n\t.st80{fill:url(#SVGID_00000005978793576678135390000004766608560120365458_);}\r\n\t.st81{fill:url(#SVGID_00000023996889440262934820000011087651272728502660_);}\r\n\t.st82{fill:url(#SVGID_00000144321920543690305680000014081540671013662115_);}\r\n\t.st83{fill:#FFA38C;}\r\n\t.st84{fill:url(#SVGID_00000083081622162991029450000008022048590703332004_);}\r\n\t.st85{fill:url(#SVGID_00000055699653332498928540000006617547659475797680_);}\r\n\t.st86{fill:url(#SVGID_00000111884732804323084850000017052184903839950235_);}\r\n\t.st87{fill:url(#SVGID_00000163033433287410854600000010867019788130513311_);}\r\n\t.st88{fill:url(#SVGID_00000105402786398304801320000014709815245924462263_);}\r\n\t.st89{fill:url(#SVGID_00000159435170227541241000000003894103208449124254_);}\r\n\t.st90{fill:url(#SVGID_00000138564263497171750090000013446872990114295719_);}\r\n\t.st91{fill:url(#SVGID_00000158010451151392251200000007471865675292344472_);}\r\n\t.st92{fill:url(#SVGID_00000160883472772248566720000014535438574259907212_);}\r\n\t.st93{fill:url(#SVGID_00000097466409272408796850000000625453352600562593_);}\r\n\t.st94{fill:url(#SVGID_00000116931409770566377310000003989147591028761750_);}\r\n\t.st95{fill:url(#SVGID_00000139998075917623935830000009054360904504966555_);}\r\n\t.st96{fill:url(#SVGID_00000141448275640930942650000017499879272914740624_);}\r\n\t.st97{fill:url(#SVGID_00000024719802054084335760000015320702380995177873_);}\r\n\t.st98{fill:url(#SVGID_00000183957415458614532290000000527176210533682848_);}\r\n\t.st99{fill:url(#SVGID_00000110432882585398374980000003274666385081947809_);}\r\n\t.st100{fill:url(#SVGID_00000024690959625605799430000011616524838858954653_);}\r\n\t.st101{fill:url(#SVGID_00000051366327913323951510000015598633583047230376_);}\r\n\t.st102{fill:url(#SVGID_00000018919028302383368060000004434047621048143795_);}\r\n\t.st103{fill:#FF5349;}\r\n\t.st104{fill:url(#SVGID_00000178924467673262277870000011753433742882340500_);}\r\n\t.st105{fill:url(#SVGID_00000035498937400308361320000008831235250550252676_);}\r\n\t.st106{fill:#DE493F;}\r\n\t.st107{fill:url(#SVGID_00000067920267576041233240000009567156904381786795_);}\r\n\t.st108{fill:url(#SVGID_00000137847650907939880590000003810769299739097526_);}\r\n\t.st109{fill:url(#SVGID_00000015333536240805795370000015354160139096653491_);}\r\n\t.st110{fill:url(#SVGID_00000158713321608919125560000005728706838820975494_);}\r\n\t.st111{fill:#19BAB7;}\r\n\t.st112{fill:url(#SVGID_00000026142519742643695340000001001067620946167188_);}\r\n\t.st113{fill:url(#SVGID_00000109731738461930270230000011465721692150322819_);}\r\n\t.st114{fill:url(#SVGID_00000065759099496551124630000014310062340094519436_);}\r\n\t.st115{clip-path:url(#SVGID_00000168075556883839238940000014524716348404347319_);}\r\n\t.st116{clip-path:url(#SVGID_00000168075556883839238940000014524716348404347319_);fill:#D6EAFF;}\r\n\t.st117{clip-path:url(#SVGID_00000168075556883839238940000014524716348404347319_);fill:#BCD9F7;}\r\n\t.st118{clip-path:url(#SVGID_00000168075556883839238940000014524716348404347319_);fill:#9CC3ED;}\r\n\t.st119{fill:url(#SVGID_00000047020709083194053230000000043573574662118587_);}\r\n\t.st120{fill:url(#SVGID_00000021086454961955371880000002175993480988412094_);}\r\n\t.st121{fill:url(#SVGID_00000173141227566043459180000011655666699615222177_);}\r\n\t.st122{fill:url(#SVGID_00000057109473945845364700000003122219426883919549_);}\r\n\t.st123{fill:url(#SVGID_00000131365055830771162960000014603572814520802989_);}\r\n\t.st124{fill:url(#SVGID_00000047047849736899168270000013661880637992806558_);}\r\n\t.st125{fill:url(#SVGID_00000119821401610629378750000016279790424185690287_);}\r\n\t.st126{fill:url(#SVGID_00000044157449958151400770000017946459915624760473_);}\r\n\t.st127{fill:url(#SVGID_00000173878679135276500350000000631861503567637431_);}\r\n\t.st128{clip-path:url(#SVGID_00000168075556883839238940000014524716348404347319_);fill:#95BBE3;}\r\n\t.st129{clip-path:url(#SVGID_00000168075556883839238940000014524716348404347319_);fill:#ACCFF2;}\r\n\t\r\n\t\t.st130{clip-path:url(#SVGID_00000166638334835800248440000002408129426724990104_);fill:url(#SVGID_00000023280834622433853330000012153003694030743707_);}\r\n\t\r\n\t\t.st131{clip-path:url(#SVGID_00000166638334835800248440000002408129426724990104_);fill:url(#SVGID_00000161617068378341815670000015162619971178092673_);}\r\n\t.st132{fill:url(#SVGID_00000155125994234741154320000013770404557311478452_);}\r\n\t.st133{fill:url(#SVGID_00000036971252895330688200000004561515218918213512_);}\r\n\t.st134{fill:url(#SVGID_00000110436341459794041800000013960269903210812325_);}\r\n\t.st135{fill:url(#SVGID_00000012470700633046518380000002220055904924206239_);}\r\n\t.st136{fill:url(#SVGID_00000144331843588235149030000015446007815111551393_);}\r\n\t.st137{fill:url(#SVGID_00000034053507648183837100000011264703749268381339_);}\r\n\t.st138{fill:url(#SVGID_00000026149592692183523340000010983463631191265714_);}\r\n\t.st139{fill:url(#SVGID_00000021811771011067284710000016136636944824632980_);}\r\n\t.st140{fill:url(#SVGID_00000057131901189148079660000007176422999435138489_);}\r\n\t.st141{fill:url(#SVGID_00000035495526809350170890000015142702861773426869_);}\r\n\t.st142{fill:url(#SVGID_00000007395293891767348740000012682443080406110639_);}\r\n\t.st143{fill:url(#SVGID_00000009573330571444527900000017498582080420250500_);}\r\n\t.st144{fill:url(#SVGID_00000111160677034856900930000007692201410521862841_);}\r\n\t.st145{fill:url(#SVGID_00000068634979720285645130000007659940143859472025_);}\r\n\t.st146{fill:url(#SVGID_00000039822253747320973580000000116024962819689127_);}\r\n\t.st147{fill:url(#SVGID_00000063619567864587878560000013698992750440003253_);}\r\n\t.st148{fill:url(#SVGID_00000067233657109854465740000002958784295650993310_);}\r\n\t.st149{fill:url(#SVGID_00000108278086508574147150000001012932136492819381_);}\r\n\t.st150{fill:url(#SVGID_00000038410215800187237160000001799658072448228001_);}\r\n\t.st151{fill:url(#SVGID_00000016062466548522460600000009973279142516897977_);}\r\n\t.st152{fill:url(#SVGID_00000173877204126861265850000015145217258045086385_);}\r\n\t.st153{fill:url(#SVGID_00000072979993404508591240000013490396641406896786_);}\r\n\t.st154{fill:url(#SVGID_00000038399097680512039310000004344497379752037805_);}\r\n\t.st155{fill:url(#SVGID_00000157282001898534714230000014755498592672365696_);}\r\n\t.st156{fill:url(#SVGID_00000085226598061682178040000013616975992030607762_);}\r\n\t.st157{fill:url(#SVGID_00000068654869505342138440000007754847219680095122_);}\r\n\t.st158{fill:url(#SVGID_00000058562101919307723390000006860251222609177275_);}\r\n\t.st159{fill:url(#SVGID_00000010991504519851912670000003562062734997359274_);}\r\n\t.st160{fill:url(#SVGID_00000148636911484777091670000011460455677212255160_);}\r\n\t.st161{fill:url(#SVGID_00000008847287490184123950000002233678552523820943_);}\r\n\t.st162{fill:url(#SVGID_00000142875472330027396760000017264201649154908558_);}\r\n\t.st163{fill:url(#SVGID_00000127011074976279480790000015953230988367423675_);}\r\n\t.st164{fill:url(#SVGID_00000030486197426895577230000012186948949646265729_);}\r\n\t.st165{fill:url(#SVGID_00000067949506793505610600000012230347321349843391_);}\r\n\t.st166{fill:url(#SVGID_00000124147234487822997960000008543832468537394852_);}\r\n\t.st167{fill:url(#SVGID_00000077283774740352680710000009174608293176511662_);}\r\n\t.st168{fill:url(#SVGID_00000171683059483741282110000018134595686999329429_);}\r\n\t.st169{fill:url(#SVGID_00000090277023214805259600000016896227063192656021_);}\r\n\t.st170{fill:url(#SVGID_00000075123131237462020610000006659037540805635262_);}\r\n\t.st171{fill:url(#SVGID_00000059994176439093842730000004003570638659279039_);}\r\n\t.st172{fill:url(#SVGID_00000019670596808875957000000002996523146063681214_);}\r\n\t.st173{fill:url(#SVGID_00000003793746466549762860000000679364548094734210_);}\r\n\t.st174{fill:url(#SVGID_00000019677442564018597410000000540050386493601955_);}\r\n\t.st175{fill:url(#SVGID_00000039104124319476187070000015167325720325051015_);}\r\n\t.st176{fill:url(#SVGID_00000099620016921556084240000009713686505680287141_);}\r\n\t.st177{fill:url(#SVGID_00000051355906315693982390000006305472272224752530_);}\r\n\t.st178{fill:url(#SVGID_00000120536449362790000020000000967210843128663982_);}\r\n\t.st179{fill:url(#SVGID_00000071535931866608703230000009446080663796218547_);}\r\n\t.st180{fill:url(#SVGID_00000132062351061494962840000002643936432187630001_);}\r\n\t.st181{fill:url(#SVGID_00000030468220455528243260000000033730210200673408_);}\r\n\t.st182{fill:url(#SVGID_00000176729373808027779510000014018387652349194164_);}\r\n\t.st183{fill:url(#SVGID_00000135655668956104918060000003613856170921080469_);}\r\n\t.st184{fill:url(#SVGID_00000029758706856589933860000009877881751860976317_);}\r\n\t.st185{fill:url(#SVGID_00000134971775944051432270000014837556324203371180_);}\r\n\t.st186{fill:url(#SVGID_00000054264372918193881740000016919302709586921376_);}\r\n\t.st187{fill:url(#SVGID_00000116207285975511813390000015306559099640568474_);}\r\n\t.st188{fill:url(#SVGID_00000078751348412689215240000004494333593054477446_);}\r\n\t.st189{fill:url(#SVGID_00000101808317597799255220000004979088802110847139_);}\r\n\t.st190{fill:url(#SVGID_00000158004685913794438800000016396182989209868938_);}\r\n\t.st191{fill:url(#SVGID_00000078046912371767791730000007766719356304798378_);}\r\n\t.st192{fill:url(#SVGID_00000085959495458891736670000003801792246482427047_);}\r\n\t.st193{fill:url(#SVGID_00000042012864162625345160000009355733960733893813_);}\r\n\t.st194{fill:url(#SVGID_00000113350008641313311210000009659662489928053170_);}\r\n\t.st195{fill:url(#SVGID_00000181775196467874082220000006144631921339238578_);}\r\n\t.st196{fill:url(#SVGID_00000089536942380865796680000012783859873231766660_);}\r\n\t.st197{fill:url(#SVGID_00000074434101236970567200000005656669565069376949_);}\r\n\t.st198{fill:url(#SVGID_00000127725870148593223170000004181220625548250253_);}\r\n\t.st199{fill:url(#SVGID_00000167382772428383263470000018106857534562495678_);}\r\n\t.st200{fill:url(#SVGID_00000065044194648076961430000009154457439780522911_);}\r\n\t.st201{fill:url(#SVGID_00000155122363420784594730000007281642728191315073_);}\r\n\t.st202{fill:url(#SVGID_00000080915246948072111280000013632487409231669665_);}\r\n\t.st203{fill:url(#SVGID_00000150074097495183407760000014928128420745035427_);}\r\n\t.st204{fill:url(#SVGID_00000181788801576001713050000017373357482372385212_);}\r\n\t.st205{fill:url(#SVGID_00000072251489630917088440000012337715017534778557_);}\r\n\t.st206{fill:url(#SVGID_00000180343895404604461390000000654503001763936418_);}\r\n\t.st207{fill:url(#SVGID_00000170982705985694520770000017482204761045352621_);}\r\n\t.st208{fill:url(#SVGID_00000117660751447091084320000004116741545183141264_);}\r\n\t.st209{fill:url(#SVGID_00000046330713701404103030000006822278249962798215_);}\r\n\t.st210{fill:url(#SVGID_00000016034893243384975200000007450966749933387158_);}\r\n\t.st211{fill:url(#SVGID_00000070808050049078749160000012006010848565996961_);}\r\n\t.st212{fill:url(#SVGID_00000023971939612736202470000017293966911604089755_);}\r\n\t.st213{fill:url(#SVGID_00000163792735582462085220000014944899882689669563_);}\r\n\t.st214{fill:url(#SVGID_00000128453882592824694630000004332896401689530292_);}\r\n\t.st215{fill:url(#SVGID_00000168797170825296267270000013105613851631717529_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1221.5,356.2c0,65.3-17.6,106.3-48.3,131.9c-61.6,51.4-176,41-307,41s-245.3,10.4-307-41 c-30.7-25.6-48.3-66.6-48.3-131.9c0-196.2,159.1-484.5,355.3-484.5C-1380.6-128.3-1221.5,160-1221.5,356.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-1221.9,356.2c0,65.3-17.6,106.3-48.3,131.9c-61.6,51.4-176,41-307,41s-245.3,10.4-307-41 c-30.7-25.6-48.3-66.6-48.3-131.9c0-196.2,159.1-484.5,355.3-484.5C-1381-128.3-1221.9,160-1221.9,356.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137106010066861792280000018130077158845181324_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1380.7,
    y: -28.8,
    className: "st2",
    width: 101.4,
    height: 157.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1363.5,
    y: -9.2,
    className: "st0",
    width: 67,
    height: 121.3
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -1959.4,
    y: 487.7,
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#D6EAFF"
    },
    width: 752.1,
    height: 92.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1997.9,
    y: 320.9,
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#BCD9F7"
    },
    width: 851.1,
    height: 157
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1997.9,
    y: 320.9,
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#9CC3ED"
    },
    width: 851.1,
    height: 10.4
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007396755114183000680000000655926932076039600_",
    gradientUnits: "userSpaceOnUse",
    x1: -1340.0673,
    y1: 222.4839,
    x2: -1305.5646,
    y2: 159.8239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007396755114183000680000000655926932076039600_)"
    },
    d: "M-1341.2,271.1 c-6.3-44.2,14.6-46.3,7.2-83.5s7.2-55.5,3.7-71.5c11,21.1,16.5,48.5,11.8,77.1c-4.7,28.6,9,59.5,1.6,75.9L-1341.2,271.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136387921235810363050000015055117432902657457_",
    gradientUnits: "userSpaceOnUse",
    x1: -1351.153,
    y1: 251.4376,
    x2: -1342.153,
    y2: 183.742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4296,
    style: {
      stopColor: "#B5E25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136387921235810363050000015055117432902657457_)"
    },
    d: "M-1345.5,276.2 c-22.4-55.6-9.1-72.4-4.4-106s-4.7-63-11.3-74.3c16.4,9,38,53.2,28.6,97c-9.4,43.8,14.5,66.5,8.2,88 C-1330.8,302.4-1345.5,276.2-1345.5,276.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139996749540921930220000006092074376615488394_",
    gradientUnits: "userSpaceOnUse",
    x1: -1355.7218,
    y1: 244.9153,
    x2: -1369.8087,
    y2: 199.9153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139996749540921930220000006092074376615488394_)"
    },
    d: "M-1349.5,296.1 c11.5-45.7,2.8-46.7-4.5-72.4s-6.5-60.1-2.5-69.7c-11.8,8.8-27,60.2-15,93.3s-1.1,38.7,6.1,54.8 C-1358.2,318.1-1349.5,296.1-1349.5,296.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058559231749874675960000013214645807304235918_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.4442,
    y1: 236.0513,
    x2: 461.9865,
    y2: 199.4503,
    gradientTransform: "matrix(-1 0 0 1 -840.494 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058559231749874675960000013214645807304235918_)"
    },
    d: "M-1319,277.7c-9.4-37.1-2.3-38,3.6-58.9 s5.3-48.9,2.1-56.7c9.6,7.1,21.9,48.9,12.2,75.9c-9.8,26.9,0.9,31.5-5,44.5C-1311.9,295.5-1319,277.7-1319,277.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183235838889134256580000003703267327264551325_",
    gradientUnits: "userSpaceOnUse",
    x1: -1362.2938,
    y1: 238.6491,
    x2: -1360.533,
    y2: 174.6708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183235838889134256580000003703267327264551325_)"
    },
    d: "M-1356.6,264.8 c-1.9-5.9-3.6-11.9-5.2-17.8c-1.6-6-3-12-4.1-18.1c-1-6.1-1.8-12.3-1.9-18.5c0-1.6,0-3.1,0-4.7l0.2-4.7l0.5-4.6l0.7-4.6 c-0.6,6.2-0.9,12.4-0.6,18.5c0.3,6.2,1,12.3,2.1,18.4c1,6.1,2.4,12.1,3.9,18.1L-1356.6,264.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085216515234869610760000007700909092280003730_",
    gradientUnits: "userSpaceOnUse",
    x1: -1328.4941,
    y1: 239.5793,
    x2: -1326.7333,
    y2: 175.6011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085216515234869610760000007700909092280003730_)"
    },
    d: "M-1331.3,259.9 c1.1-4.4,2.2-8.7,2.8-13.2c0.4-2.2,0.6-4.5,0.9-6.7c0.2-2.2,0.4-4.5,0.5-6.7c0.3-4.5,0.4-9,0.4-13.5c0-4.5-0.1-9-0.3-13.5 c-0.1-4.5-0.3-9-0.4-13.5c0-2.3,0.1-4.5,0.2-6.8c0.1-2.3,0.3-4.5,0.5-6.8l1.2-13.5c0.4-4.5,0.8-9,0.7-13.5 c0.2,2.2,0.2,4.5,0.1,6.8c-0.1,2.3-0.2,4.5-0.3,6.8l-0.9,13.5l-0.4,6.7c-0.1,2.3-0.2,4.5-0.2,6.7c0.1,4.5,0.3,9,0.5,13.5 c0.3,9,0.3,18.1-0.4,27.1C-1327,242.3-1328.5,251.3-1331.3,259.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088115822248452647140000002897467324800717715_",
    gradientUnits: "userSpaceOnUse",
    x1: -1343.2146,
    y1: 239.1742,
    x2: -1341.4537,
    y2: 175.1959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088115822248452647140000002897467324800717715_)"
    },
    d: "M-1339.6,264.6 c-2.6-10.1-4.8-20.4-6-30.9c-0.7-5.2-1-10.5-1.1-15.7c-0.1-5.3,0.2-10.5,0.8-15.7c0.6-5.2,1.6-10.4,2.7-15.5 c0.3-1.3,0.5-2.6,0.7-3.8l0.3-1.9l0.2-1.9c0.2-1.3,0.3-2.6,0.4-3.9c0.1-1.3,0.2-2.6,0.3-3.9c0.3-5.2,0.2-10.5,0-15.7 c-0.2-5.2-0.5-10.5-1-15.7c1.3,10.4,2,20.9,1.7,31.4c-0.1,5.2-0.7,10.5-1.8,15.7c-1,5.1-2,10.3-2.6,15.5 c-0.6,5.2-0.9,10.4-0.9,15.6c0.1,5.2,0.4,10.4,1,15.6c0.2,2.6,0.7,5.2,1,7.8l1.3,7.7c0.5,2.6,0.9,5.2,1.4,7.7L-1339.6,264.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011718947495113269160000012097175914103438743_",
    gradientUnits: "userSpaceOnUse",
    x1: -1316.6073,
    y1: 239.9065,
    x2: -1314.8464,
    y2: 175.9282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011718947495113269160000012097175914103438743_)"
    },
    d: "M-1328,264.8l5.7-8 c1.9-2.7,3.7-5.4,5.4-8.2c1.7-2.8,3.2-5.7,4.6-8.6c0.6-1.5,1.3-3,1.8-4.5l0.8-2.3l0.4-1.2l0.3-1.2c1.8-6.3,2.6-12.8,3.1-19.3 l0.3-4.9c0.1-1.6,0.1-3.3,0.1-4.9c0.2-3.3,0-6.6,0.1-9.8c0.4,6.6,0.6,13.1,0.3,19.7c-0.3,6.6-1.2,13.1-2.9,19.5l-0.3,1.2 l-0.4,1.2l-0.8,2.3c-0.6,1.6-1.2,3.1-1.9,4.6c-1.4,3-2.9,5.9-4.8,8.7C-1319.8,254.6-1323.9,259.7-1328,264.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176035174053787042350000017056863450665808530_",
    gradientUnits: "userSpaceOnUse",
    x1: -1329.6018,
    y1: 288.7308,
    x2: -1275.3409,
    y2: 326.296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8D3E8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000176035174053787042350000017056863450665808530_)"
    },
    points: "-1297.6,250.3 -1374.6,250.3  -1370.6,320.9 -1302.6,320.9  "
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1296.7,257.2h-78.7c-3.3,0-5.9-2.6-5.9-5.9v0c0-3.3,2.6-5.9,5.9-5.9h78.7c3.3,0,5.9,2.6,5.9,5.9v0 C-1290.8,254.6-1293.5,257.2-1296.7,257.2z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -1853.8,
    y: 478,
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#95BBE3"
    },
    width: 52.2,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1703.5,
    y: 478,
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#95BBE3"
    },
    width: 52.2,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1509.7,
    y: 478,
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#95BBE3"
    },
    width: 52.2,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1359.5,
    y: 478,
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#95BBE3"
    },
    width: 52.2,
    height: 9.7
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1701.7,385.4h-177.6c-1.8,0-3.2-1.4-3.2-3.2v-34.4c0-1.8,1.4-3.2,3.2-3.2h177.6c1.8,0,3.2,1.4,3.2,3.2 v34.4C-1698.5,383.9-1699.9,385.4-1701.7,385.4z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -1790.5,
    cy: 365,
    r: 8.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1313.1,385.4h-177.6c-1.8,0-3.2-1.4-3.2-3.2v-34.4c0-1.8,1.4-3.2,3.2-3.2h177.6c1.8,0,3.2,1.4,3.2,3.2 v34.4C-1309.9,383.9-1311.3,385.4-1313.1,385.4z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -1401.8,
    cy: 365,
    r: 8.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1313.1,434.6h-177.6c-1.8,0-3.2-1.4-3.2-3.2V397c0-1.8,1.4-3.2,3.2-3.2h177.6c1.8,0,3.2,1.4,3.2,3.2v34.4 C-1309.9,433.2-1311.3,434.6-1313.1,434.6z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -1401.8,
    cy: 414.2,
    r: 8.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1701.7,465.4h-177.6c-1.8,0-3.2-1.4-3.2-3.2V397c0-1.8,1.4-3.2,3.2-3.2h177.6c1.8,0,3.2,1.4,3.2,3.2v65.2 C-1698.5,464-1699.9,465.4-1701.7,465.4z"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#9CC3ED"
    },
    cx: -1790.5,
    cy: 414.2,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#9CC3ED"
    },
    d: "M-1314.6,442.1h-174.9 c-2.6,0-4.8,2.1-4.8,4.8V478h184.4v-31.1C-1309.9,444.2-1312,442.1-1314.6,442.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#ACCFF2"
    },
    d: "M-1505.5,463.8h-182.4 c-1,0-1.8-0.8-1.8-1.8V346.2c0-1,0.8-1.8,1.8-1.8h182.4c1,0,1.8,0.8,1.8,1.8V462C-1503.7,463-1504.5,463.8-1505.5,463.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#ACCFF2"
    },
    d: "M-1117.3,463.8h-182.4 c-1,0-1.8-0.8-1.8-1.8V346.2c0-1,0.8-1.8,1.8-1.8h182.4c1,0,1.8,0.8,1.8,1.8V462C-1115.5,463-1116.3,463.8-1117.3,463.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)",
      fill: "#ACCFF2"
    },
    d: "M-1893.8,463.8h-182.4 c-1,0-1.8-0.8-1.8-1.8V346.2c0-1,0.8-1.8,1.8-1.8h182.4c1,0,1.8,0.8,1.8,1.8V462C-1892,463-1892.8,463.8-1893.8,463.8z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1701,
    y: -158.6,
    className: "st19",
    width: 247.6,
    height: 451.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -1686.3,
    y: -145.7,
    className: "st20",
    width: 218.1,
    height: 425.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -1686.3,
    y: 58.1,
    className: "st19",
    width: 218.1,
    height: 17.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -1686.3,
    y: 76,
    className: "st21",
    width: 218.1,
    height: 6.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -1792.4,
    y: 55.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -1512.7371 1641.6976)",
    className: "st19",
    width: 430.4,
    height: 17.9
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108294353857924656130000008166879236013727111_",
    x: -1686.3,
    y: -145.7,
    width: 218.1,
    height: 425.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042731525456885688270000018082114620670799236_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108294353857924656130000008166879236013727111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106857797010553216070000013266730644729562509_",
    gradientUnits: "userSpaceOnUse",
    x1: -1455.7382,
    y1: -67.7549,
    x2: -1452.0861,
    y2: -25.494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F6F9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000042731525456885688270000018082114620670799236_)",
      fill: "url(#SVGID_00000106857797010553216070000013266730644729562509_)"
    },
    d: " M-1539-41.1c12.5-31.5,34.4-37.9,51.7-20.6s32.1-4.6,51.7-0.7c19.6,3.9,21.5,21.3,67.9,21.3H-1539z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035508537740322966110000013751844744747503521_",
    gradientUnits: "userSpaceOnUse",
    x1: -1651.7111,
    y1: -0.4672,
    x2: -1649.4971,
    y2: 25.1519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F6F9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000042731525456885688270000018082114620670799236_)",
      fill: "url(#SVGID_00000035508537740322966110000013751844744747503521_)"
    },
    d: " M-1695.4,16.3c6.6-20.1,18.2-24.2,27.2-13.2s16.9-2.9,27.2-0.4c10.3,2.5,11.3,13.6,35.8,13.6H-1695.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035494200883613112100000001221303088483496634_",
    gradientUnits: "userSpaceOnUse",
    x1: -1689.4707,
    y1: 333.7895,
    x2: -1672.3491,
    y2: 333.7895,
    gradientTransform: "matrix(0.9959 -9.093526e-02 9.093526e-02 0.9959 -34.33 -59.3004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035494200883613112100000001221303088483496634_)"
    },
    d: "M-1676.9,388l-8.9,0.8 c-2.3,0.2-3.9,2.2-3.7,4.5l6.1,66.9c0.2,2.3,2.2,3.9,4.5,3.7l8.9-0.8c2.3-0.2,3.9-2.2,3.7-4.5l-6.1-66.9 C-1672.7,389.5-1674.7,387.8-1676.9,388z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073000965411698871520000013594888861768005802_",
    gradientUnits: "userSpaceOnUse",
    x1: -1665.5044,
    y1: 304.5177,
    x2: -1685.8522,
    y2: 305.8221,
    gradientTransform: "matrix(0.9959 -9.093526e-02 9.093526e-02 0.9959 -34.33 -59.3004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000073000965411698871520000013594888861768005802_)"
    },
    points: "-1671.8,398.6 -1688.9,400.1  -1689.2,397 -1672.1,395.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036212084351523008470000000741021066725213599_",
    gradientUnits: "userSpaceOnUse",
    x1: -1665.5044,
    y1: 360.996,
    x2: -1685.8522,
    y2: 362.3003,
    gradientTransform: "matrix(0.9959 -9.093526e-02 9.093526e-02 0.9959 -34.33 -59.3004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000036212084351523008470000000741021066725213599_)"
    },
    points: "-1666.7,454.8 -1683.7,456.4  -1684,453.3 -1667,451.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133502798738412090050000001259890017846170014_",
    gradientUnits: "userSpaceOnUse",
    x1: -1675.5544,
    y1: 332.1589,
    x2: -1682.6913,
    y2: 332.6164,
    gradientTransform: "matrix(0.9959 -9.093526e-02 9.093526e-02 0.9959 -34.33 -59.3004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133502798738412090050000001259890017846170014_)"
    },
    d: "M-1675.8,442.7l-1.3,0.1 c-0.7,0.1-1.4-0.5-1.4-1.2l-3.1-33.5c-0.1-0.7,0.5-1.4,1.2-1.4l1.3-0.1c0.7-0.1,1.4,0.5,1.4,1.2l3.1,33.5 C-1674.5,442-1675.1,442.6-1675.8,442.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035520640611719244380000006560597889631974306_",
    gradientUnits: "userSpaceOnUse",
    x1: -484.9396,
    y1: 1321.9373,
    x2: -467.818,
    y2: 1321.9373,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035520640611719244380000006560597889631974306_)"
    },
    d: "M-1509.9,459.4l0-8.9 c0-2.3-1.9-4.1-4.1-4.1l-67.1,0.2c-2.3,0-4.1,1.9-4.1,4.1l0,8.9c0,2.3,1.9,4.1,4.1,4.1l67.1-0.2 C-1511.8,463.5-1509.9,461.7-1509.9,459.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056405575108784866150000004795513078005576346_",
    gradientUnits: "userSpaceOnUse",
    x1: -460.9732,
    y1: 1292.6655,
    x2: -481.321,
    y2: 1293.9698,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000056405575108784866150000004795513078005576346_)"
    },
    points: "-1520.9,463.6 -1520.9,446.5  -1517.8,446.4 -1517.7,463.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163768920144469135270000016447068730915708815_",
    gradientUnits: "userSpaceOnUse",
    x1: -460.9732,
    y1: 1349.1438,
    x2: -481.321,
    y2: 1350.4481,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000163768920144469135270000016447068730915708815_)"
    },
    points: "-1577.3,463.8 -1577.4,446.7  -1574.3,446.6 -1574.2,463.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074414918455185884220000001889651897090531774_",
    gradientUnits: "userSpaceOnUse",
    x1: -471.0233,
    y1: 1320.3066,
    x2: -478.1601,
    y2: 1320.7642,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074414918455185884220000001889651897090531774_)"
    },
    d: "M-1564.5,455.8l0-1.3 c0-0.7,0.6-1.3,1.3-1.3l33.7-0.1c0.7,0,1.3,0.6,1.3,1.3l0,1.3c0,0.7-0.6,1.3-1.3,1.3l-33.7,0.1 C-1563.9,457.1-1564.5,456.5-1564.5,455.8z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114034487405106377730000012965092234175144367_",
    gradientUnits: "userSpaceOnUse",
    x1: -501.7889,
    y1: 1328.5304,
    x2: -484.6673,
    y2: 1328.5304,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114034487405106377730000012965092234175144367_)"
    },
    d: "M-1516.6,442.6l0-8.9 c0-2.3-1.9-4.1-4.1-4.1l-67.1,0.2c-2.3,0-4.1,1.9-4.1,4.1l0,8.9c0,2.3,1.9,4.1,4.1,4.1l67.1-0.2 C-1518.4,446.7-1516.6,444.9-1516.6,442.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064346322315874923730000017093694650216386485_",
    gradientUnits: "userSpaceOnUse",
    x1: -477.8225,
    y1: 1299.2587,
    x2: -498.1703,
    y2: 1300.563,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000064346322315874923730000017093694650216386485_)"
    },
    points: "-1527.5,446.8 -1527.6,429.6  -1524.5,429.6 -1524.4,446.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083084125983178765720000014402162523267831936_",
    gradientUnits: "userSpaceOnUse",
    x1: -477.8225,
    y1: 1355.7369,
    x2: -498.1703,
    y2: 1357.0413,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000083084125983178765720000014402162523267831936_)"
    },
    points: "-1584,447 -1584.1,429.8  -1580.9,429.8 -1580.9,446.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168110238219379730870000007580207788565434011_",
    gradientUnits: "userSpaceOnUse",
    x1: -487.8726,
    y1: 1326.8998,
    x2: -495.0094,
    y2: 1327.3573,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168110238219379730870000007580207788565434011_)"
    },
    d: "M-1571.1,438.9l0-1.3 c0-0.7,0.6-1.3,1.3-1.3l33.7-0.1c0.7,0,1.3,0.6,1.3,1.3l0,1.3c0,0.7-0.6,1.3-1.3,1.3l-33.7,0.1 C-1570.5,440.3-1571.1,439.7-1571.1,438.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084523047452153971090000008908239380185053089_",
    gradientUnits: "userSpaceOnUse",
    x1: -518.9808,
    y1: 1321.231,
    x2: -501.8592,
    y2: 1321.231,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084523047452153971090000008908239380185053089_)"
    },
    d: "M-1509.3,425.4l0-8.9 c0-2.3-1.9-4.1-4.1-4.1l-67.1,0.2c-2.3,0-4.1,1.9-4.1,4.1l0,8.9c0,2.3,1.9,4.1,4.1,4.1l67.1-0.2 C-1511.2,429.5-1509.3,427.7-1509.3,425.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089573644216864779950000013100025192641827973_",
    gradientUnits: "userSpaceOnUse",
    x1: -495.0144,
    y1: 1291.9592,
    x2: -515.3622,
    y2: 1293.2635,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000089573644216864779950000013100025192641827973_)"
    },
    points: "-1520.3,429.5 -1520.3,412.4  -1517.2,412.4 -1517.2,429.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023275761676009872580000013798059635953103248_",
    gradientUnits: "userSpaceOnUse",
    x1: -495.0144,
    y1: 1348.4375,
    x2: -515.3622,
    y2: 1349.7418,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000023275761676009872580000013798059635953103248_)"
    },
    points: "-1576.8,429.7 -1576.8,412.6  -1573.7,412.6 -1573.6,429.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014617187393545505510000016673252617648052664_",
    gradientUnits: "userSpaceOnUse",
    x1: -505.0645,
    y1: 1319.6003,
    x2: -512.2014,
    y2: 1320.0579,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014617187393545505510000016673252617648052664_)"
    },
    d: "M-1563.9,421.7l0-1.3 c0-0.7,0.6-1.3,1.3-1.3l33.7-0.1c0.7,0,1.3,0.6,1.3,1.3l0,1.3c0,0.7-0.6,1.3-1.3,1.3l-33.7,0.1 C-1563.3,423-1563.9,422.5-1563.9,421.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109004718248677599360000007524053239697605249_",
    gradientUnits: "userSpaceOnUse",
    x1: -628.8161,
    y1: 1607.1405,
    x2: -611.6945,
    y2: 1607.1405,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109004718248677599360000007524053239697605249_)"
    },
    d: "M-1795.6,316.6l0-8.9 c0-2.3-1.9-4.1-4.1-4.1l-67.1,0.2c-2.3,0-4.1,1.9-4.1,4.1l0,8.9c0,2.3,1.9,4.1,4.1,4.1l67.1-0.2 C-1797.5,320.7-1795.6,318.8-1795.6,316.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088812424179274682030000012112046024426906515_",
    gradientUnits: "userSpaceOnUse",
    x1: -604.8497,
    y1: 1577.8688,
    x2: -625.1976,
    y2: 1579.1731,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000088812424179274682030000012112046024426906515_)"
    },
    points: "-1806.6,320.7 -1806.6,303.6  -1803.5,303.6 -1803.4,320.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139994336609585569620000000925147290248965053_",
    gradientUnits: "userSpaceOnUse",
    x1: -604.8497,
    y1: 1634.347,
    x2: -625.1976,
    y2: 1635.6514,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000139994336609585569620000000925147290248965053_)"
    },
    points: "-1863.1,320.9 -1863.1,303.8  -1860,303.8 -1859.9,320.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158716716356922579340000012406290210890823090_",
    gradientUnits: "userSpaceOnUse",
    x1: -614.8998,
    y1: 1605.51,
    x2: -622.0366,
    y2: 1605.9674,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158716716356922579340000012406290210890823090_)"
    },
    d: "M-1850.2,312.9l0-1.3 c0-0.7,0.6-1.3,1.3-1.3l33.7-0.1c0.7,0,1.3,0.6,1.3,1.3l0,1.3c0,0.7-0.6,1.3-1.3,1.3l-33.7,0.1 C-1849.6,314.2-1850.2,313.6-1850.2,312.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060749872261155803800000012310352229518274713_",
    gradientUnits: "userSpaceOnUse",
    x1: -645.6489,
    y1: 1609.0381,
    x2: -628.5273,
    y2: 1609.0381,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060749872261155803800000012310352229518274713_)"
    },
    d: "M-1797.6,299.7l0-8.9 c0-2.3-1.9-4.1-4.1-4.1l-67.1,0.2c-2.3,0-4.1,1.9-4.1,4.1l0,8.9c0,2.3,1.9,4.1,4.1,4.1l67.1-0.2 C-1799.4,303.8-1797.6,302-1797.6,299.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088123851643624893590000016918304901269547920_",
    gradientUnits: "userSpaceOnUse",
    x1: -621.6826,
    y1: 1579.7664,
    x2: -642.0304,
    y2: 1581.0707,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000088123851643624893590000016918304901269547920_)"
    },
    points: "-1808.5,303.9 -1808.6,286.8  -1805.5,286.7 -1805.4,303.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022543967625627977900000017782704149442338468_",
    gradientUnits: "userSpaceOnUse",
    x1: -621.6826,
    y1: 1636.2446,
    x2: -642.0304,
    y2: 1637.549,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000022543967625627977900000017782704149442338468_)"
    },
    points: "-1865,304.1 -1865.1,287  -1861.9,286.9 -1861.9,304.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033344705654983256040000009187780451979080833_",
    gradientUnits: "userSpaceOnUse",
    x1: -631.7326,
    y1: 1607.4075,
    x2: -638.8695,
    y2: 1607.865,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033344705654983256040000009187780451979080833_)"
    },
    d: "M-1852.1,296.1l0-1.3 c0-0.7,0.6-1.3,1.3-1.3l33.7-0.1c0.7,0,1.3,0.6,1.3,1.3l0,1.3c0,0.7-0.6,1.3-1.3,1.3l-33.7,0.1 C-1851.5,297.4-1852.1,296.8-1852.1,296.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130637939446547460390000002809253605656353678_",
    gradientUnits: "userSpaceOnUse",
    x1: -662.8573,
    y1: 1606.4342,
    x2: -645.7357,
    y2: 1606.4342,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130637939446547460390000002809253605656353678_)"
    },
    d: "M-1795,282.5l0-8.9 c0-2.3-1.9-4.1-4.1-4.1l-67.1,0.2c-2.3,0-4.1,1.9-4.1,4.1l0,8.9c0,2.3,1.9,4.1,4.1,4.1l67.1-0.2 C-1796.9,286.6-1795,284.8-1795,282.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070807226437579961490000014217081764828234172_",
    gradientUnits: "userSpaceOnUse",
    x1: -638.891,
    y1: 1577.1625,
    x2: -659.2388,
    y2: 1578.4668,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000070807226437579961490000014217081764828234172_)"
    },
    points: "-1806,286.7 -1806,269.5  -1802.9,269.5 -1802.9,286.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090975872169741103770000002424842983266425229_",
    gradientUnits: "userSpaceOnUse",
    x1: -638.891,
    y1: 1633.6407,
    x2: -659.2388,
    y2: 1634.9451,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000090975872169741103770000002424842983266425229_)"
    },
    points: "-1862.5,286.9 -1862.5,269.7  -1859.4,269.7 -1859.3,286.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138567745295672491390000013605525693027920522_",
    gradientUnits: "userSpaceOnUse",
    x1: -648.941,
    y1: 1604.8036,
    x2: -656.0779,
    y2: 1605.2611,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138567745295672491390000013605525693027920522_)"
    },
    d: "M-1849.6,278.9l0-1.3 c0-0.7,0.6-1.3,1.3-1.3l33.7-0.1c0.7,0,1.3,0.6,1.3,1.3l0,1.3c0,0.7-0.6,1.3-1.3,1.3l-33.7,0.1 C-1849,280.2-1849.6,279.6-1849.6,278.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163041739381448847350000000971009308220768433_",
    gradientUnits: "userSpaceOnUse",
    x1: -1653.7655,
    y1: 183.0959,
    x2: -1636.6439,
    y2: 183.0959,
    gradientTransform: "matrix(0.9705 -0.2409 0.2409 0.9705 -103.0557 -148.0743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163041739381448847350000000971009308220768433_)"
    },
    d: "M-1660.5,388.3l-8.6,2.1 c-2.2,0.5-3.5,2.8-3,5l16.2,65.2c0.5,2.2,2.8,3.5,5,3l8.6-2.1c2.2-0.5,3.5-2.8,3-5l-16.2-65.2 C-1656,389.1-1658.3,387.8-1660.5,388.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118394317324495166980000003124741057662113696_",
    gradientUnits: "userSpaceOnUse",
    x1: -1629.7992,
    y1: 153.8242,
    x2: -1650.147,
    y2: 155.1285,
    gradientTransform: "matrix(0.9705 -0.2409 0.2409 0.9705 -103.0557 -148.0743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000118394317324495166980000003124741057662113696_)"
    },
    points: "-1653.8,398 -1670.4,402.1  -1671.2,399.1 -1654.6,394.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133498399578621613910000014081059221238606750_",
    gradientUnits: "userSpaceOnUse",
    x1: -1629.7992,
    y1: 210.3024,
    x2: -1650.147,
    y2: 211.6068,
    gradientTransform: "matrix(0.9705 -0.2409 0.2409 0.9705 -103.0557 -148.0743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000133498399578621613910000014081059221238606750_)"
    },
    points: "-1640.2,452.8 -1656.8,456.9  -1657.6,453.9 -1641,449.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062178224722489462620000008718372593951180177_",
    gradientUnits: "userSpaceOnUse",
    x1: -1639.8492,
    y1: 181.4653,
    x2: -1646.9861,
    y2: 181.9228,
    gradientTransform: "matrix(0.9705 -0.2409 0.2409 0.9705 -103.0557 -148.0743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062178224722489462620000008718372593951180177_)"
    },
    d: "M-1651.1,442.2l-1.3,0.3 c-0.7,0.2-1.4-0.3-1.6-1l-8.1-32.7c-0.2-0.7,0.3-1.4,1-1.6l1.3-0.3c0.7-0.2,1.4,0.3,1.6,1l8.1,32.7 C-1649.9,441.3-1650.4,442-1651.1,442.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013190009629849165100000001222713406115447700_",
    gradientUnits: "userSpaceOnUse",
    x1: -1595.7346,
    y1: 42.6673,
    x2: -1578.613,
    y2: 42.6673,
    gradientTransform: "matrix(0.9237 -0.3831 0.3831 0.9237 -182.8316 -220.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013190009629849165100000001222713406115447700_)"
    },
    d: "M-1642.9,390.2l-8.2,3.4 c-2.1,0.9-3.1,3.3-2.2,5.4l25.7,62c0.9,2.1,3.3,3.1,5.4,2.2l8.2-3.4c2.1-0.9,3.1-3.3,2.2-5.4l-25.7-62 C-1638.4,390.4-1640.8,389.4-1642.9,390.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134216656231426749070000005538059970989121447_",
    gradientUnits: "userSpaceOnUse",
    x1: -1571.7683,
    y1: 13.3955,
    x2: -1592.1161,
    y2: 14.6999,
    gradientTransform: "matrix(0.9237 -0.3831 0.3831 0.9237 -182.8316 -220.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134216656231426749070000005538059970989121447_)"
    },
    points: "-1634.9,398.8 -1650.7,405.3  -1651.9,402.5 -1636.1,395.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031205046744716282940000009826601906223450799_",
    gradientUnits: "userSpaceOnUse",
    x1: -1571.7683,
    y1: 69.8738,
    x2: -1592.1161,
    y2: 71.1782,
    gradientTransform: "matrix(0.9237 -0.3831 0.3831 0.9237 -182.8316 -220.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031205046744716282940000009826601906223450799_)"
    },
    points: "-1613.3,451 -1629.1,457.5  -1630.3,454.6 -1614.4,448.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071557398882309362140000016979315683279669639_",
    gradientUnits: "userSpaceOnUse",
    x1: -1581.8184,
    y1: 41.0367,
    x2: -1588.9552,
    y2: 41.4942,
    gradientTransform: "matrix(0.9237 -0.3831 0.3831 0.9237 -182.8316 -220.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071557398882309362140000016979315683279669639_)"
    },
    d: "M-1625.5,442.1l-1.2,0.5 c-0.7,0.3-1.4,0-1.7-0.7l-12.9-31.1c-0.3-0.7,0-1.4,0.7-1.7l1.2-0.5c0.7-0.3,1.4,0,1.7,0.7l12.9,31.1 C-1624.6,441-1624.9,441.8-1625.5,442.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137106010066861792280000018130077158845181324_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1813.7,87.8L-1813.7,87.8c-3.2,0-5.8-2.6-5.8-5.8v0c0-3.2,2.6-5.8,5.8-5.8l0,0c3.2,0,5.8,2.6,5.8,5.8v0 C-1807.9,85.2-1810.5,87.8-1813.7,87.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1775.4,145.1L-1775.4,145.1c-3.2,0-5.8-2.6-5.8-5.8v0c0-3.2,2.6-5.8,5.8-5.8l0,0c3.2,0,5.8,2.6,5.8,5.8v0 C-1769.6,142.5-1772.2,145.1-1775.4,145.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1786,87.8h-13.3c-3.2,0-5.8-2.6-5.8-5.8v0c0-3.2,2.6-5.8,5.8-5.8h13.3c3.2,0,5.8,2.6,5.8,5.8v0 C-1780.2,85.2-1782.8,87.8-1786,87.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1775.4,102.1h-9.6c-3.2,0-5.8-2.6-5.8-5.8v0c0-3.2,2.6-5.8,5.8-5.8h9.6c3.2,0,5.8,2.6,5.8,5.8v0 C-1769.6,99.5-1772.2,102.1-1775.4,102.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1806.5,116.5h31.1c3.2,0,5.8-2.6,5.8-5.8v0c0-3.2-2.6-5.8-5.8-5.8h-31.1c-3.2,0-5.8,2.6-5.8,5.8v0 C-1812.3,113.9-1809.7,116.5-1806.5,116.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1791.7,130.8h16.4c3.2,0,5.8-2.6,5.8-5.8v0c0-3.2-2.6-5.8-5.8-5.8h-16.4c-3.2,0-5.8,2.6-5.8,5.8v0 C-1797.6,128.2-1794.9,130.8-1791.7,130.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1823.3,130.8h9.6c3.2,0,5.8-2.6,5.8-5.8v0c0-3.2-2.6-5.8-5.8-5.8h-9.6c-3.2,0-5.8,2.6-5.8,5.8v0 C-1829.1,128.2-1826.5,130.8-1823.3,130.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1804.1,145.1h9.5c3.2,0,5.8-2.6,5.8-5.8v0c0-3.2-2.6-5.8-5.8-5.8h-9.5c-3.2,0-5.8,2.6-5.8,5.8v0 C-1809.9,142.5-1807.3,145.1-1804.1,145.1z"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "-1730.6,461.8 -1740.4,481.1 -1756.4,472.4 -1744.9,451.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023269314716805867210000007130342452883066009_",
    gradientUnits: "userSpaceOnUse",
    x1: -1699.2963,
    y1: 398.1819,
    x2: -1683.1224,
    y2: 401.3123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023269314716805867210000007130342452883066009_)"
    },
    d: "M-1684.4,304.5l-16.1,189.7 c-0.2,2.5,1.5,4.6,3.5,4.6l0,0c1.7,0,3.2-1.5,3.5-3.6l27.8-190.8H-1684.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137853759809211275890000007649899470554463898_",
    gradientUnits: "userSpaceOnUse",
    x1: -1834.5237,
    y1: 215.0414,
    x2: -1818.1097,
    y2: 200.4956,
    gradientTransform: "matrix(0.9898 -0.1426 0.1426 0.9898 -58.8828 -48.8761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8FC227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4296,
    style: {
      stopColor: "#B5E25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137853759809211275890000007649899470554463898_)"
    },
    d: "M-1857.7,453.9 c-3.1-14.3,2.2-14.2,7.2-19.4c4.9-5.2-3.6-14.3-2.2-19.1c1.4-4.8,6.8-5.5,5-14.1c-1.9-8.6,3.8-10.6,7.8-10.5 c4,0.1,13,6.8,7.2,14.3c-5.8,7.5,3.3,12.1-0.8,19.9s7,16.4,0.8,22.8C-1838.9,454.1-1855.5,464.1-1857.7,453.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044872638355438779800000007269764773656339878_",
    gradientUnits: "userSpaceOnUse",
    x1: -1873.6343,
    y1: 427.6717,
    x2: -1896.5974,
    y2: 406.8749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8FC227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4296,
    style: {
      stopColor: "#B5E25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044872638355438779800000007269764773656339878_)"
    },
    d: "M-1882.9,450.7c2.8-19.4-7.1-21.2,0-32 c7.1-10.8-1.1-11.1,1.3-18.5s10.1-12.2,11.7-0.4c1.5,11.7,7.5,12.2,5.1,21.4c-2.3,9.2,6.7,26.6-2.7,31.3 S-1884,458.5-1882.9,450.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127004112755514147730000008652557961955784862_",
    gradientUnits: "userSpaceOnUse",
    x1: -1858.8678,
    y1: 458.9416,
    x2: -1858.0012,
    y2: 407.3829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4296,
    style: {
      stopColor: "#B5E25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127004112755514147730000008652557961955784862_)"
    },
    d: "M-1872.7,467.6 c-11.6-19.2-9.2-34.7-2-43.3c7.2-8.7,10-19.3,5.2-32.4c-4.8-13-0.4-31.9,10.9-31.9s16.8,13.4,11.3,32.2 c-5.5,18.8-2.1,21.4,4.7,32.1c6.8,10.7,9.4,34.4,0,43.3H-1872.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120553041156033562240000003439925433586743425_",
    gradientUnits: "userSpaceOnUse",
    x1: -1856.0115,
    y1: 442.6321,
    x2: -1858.3223,
    y2: 388.0405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120553041156033562240000003439925433586743425_)"
    },
    d: "M-1857.2,434c0.2-3.1,0.2-6.2,0-9.3 c-0.2-3.5-0.6-7-0.9-10.5c0.9-0.4,1.6-0.9,2.3-1.6c0.8-0.7,1.4-1.5,2-2.4c-1.2,1.2-2.7,2.4-4.3,2.9c-0.2-3.2-0.3-6.3,0.1-9.5 c0.4-5.2,1.7-10.3,2.1-15.5c1.8-0.7,2.7-2.4,3.6-4c-1,1.1-2.1,2.4-3.5,2.8c0.1-1.5,0.1-3-0.1-4.4c-0.4-3.5-1.4-7-2.8-10.2 c1.2,3.3,2,6.8,2.3,10.3c0.3,3.5-0.4,7-1,10.4c-0.3,1.8-0.7,3.7-1,5.5c-0.9-0.1-1.8-0.5-2.5-1.1c-0.9-0.7-1.7-1.5-2.3-2.5 c0.9,2,2.5,3.9,4.7,4.6c-0.7,4.8-1.2,9.7-0.7,14.6c0.4,3,0.7,6.1,0.9,9.1c-2.7-0.4-5.8-1.4-6.6-4.2c0.5,3.1,3.9,4.5,6.7,5.3 c0.5,10.7-0.4,21.4-1.9,32c1.3-7,2.4-14.1,2.8-21.3c1.7-0.4,3.4-1,4.9-2c1.6-1,2.8-2.5,3.6-4.1 C-1850.5,432-1853.8,433.6-1857.2,434z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124857920207786749310000006545048116511471261_",
    gradientUnits: "userSpaceOnUse",
    x1: -1853.5098,
    y1: 462.2866,
    x2: -1813.1926,
    y2: 490.1985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8D3E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124857920207786749310000006545048116511471261_)"
    },
    d: "M-1829,434.4h-58.4l2.8,49.2 c0.1,2.4,2.1,4.3,4.5,4.3h43.1c2.4,0,4.3-1.8,4.5-4.2L-1829,434.4z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M-1828.3,439.6h-59.7c-2.5,0-4.5-2-4.5-4.5v0c0-2.5,2-4.5,4.5-4.5h59.7c2.5,0,4.5,2,4.5,4.5v0 C-1823.8,437.6-1825.8,439.6-1828.3,439.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168107859059042055670000003433504854494883756_",
    gradientUnits: "userSpaceOnUse",
    x1: -1733.5502,
    y1: 359.0201,
    x2: -1769.5502,
    y2: 405.4549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2564D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168107859059042055670000003433504854494883756_)"
    },
    points: "-1751.3,456 -1730.6,467.5  -1665.6,375.1 -1695,337.1 -1791.1,320.9 -1799.3,364.8 -1716.9,380.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168082741862447341250000001012628015087291545_",
    gradientUnits: "userSpaceOnUse",
    x1: -1840.6818,
    y1: 442.0991,
    x2: -1815.2468,
    y2: 442.0991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168082741862447341250000001012628015087291545_)"
    },
    d: "M-1836.2,503.3c-0.2,0-0.4,0-0.7,0 c-2.5-0.4-4.2-2.6-3.8-5.1l16.4-113.5c0.4-2.5,2.6-4.2,5.1-3.8c2.5,0.4,4.2,2.6,3.8,5.1l-16.4,113.5 C-1832.1,501.7-1834,503.3-1836.2,503.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066493592915058131540000015859160177328600238_",
    gradientUnits: "userSpaceOnUse",
    x1: -1721.3849,
    y1: 442.0991,
    x2: -1695.95,
    y2: 442.0991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066493592915058131540000015859160177328600238_)"
    },
    d: "M-1700.5,503.3c-2.2,0-4.1-1.6-4.4-3.9 l-16.4-113.5c-0.4-2.5,1.3-4.7,3.8-5.1c2.5-0.4,4.7,1.3,5.1,3.8l16.4,113.5c0.4,2.5-1.3,4.7-3.8,5.1 C-1700,503.3-1700.2,503.3-1700.5,503.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171690310902662535090000011442717567367236511_",
    gradientUnits: "userSpaceOnUse",
    x1: -1776.963,
    y1: 335.9272,
    x2: -1766.7891,
    y2: 381.8403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171690310902662535090000011442717567367236511_)"
    },
    d: "M-1727.1,364.8h-79.4 c-8.1,0-14.6,6.5-14.6,14.6v6h108.7v-6C-1712.5,371.3-1719.1,364.8-1727.1,364.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160162728702620261390000013935867709858453428_",
    gradientUnits: "userSpaceOnUse",
    x1: -1873.1815,
    y1: 243.6135,
    x2: -1829.3555,
    y2: 343.7874
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160162728702620261390000013935867709858453428_)"
    },
    d: "M-1830,328.2l-21.5-76.5 c-2.2-7.8-10.3-12.3-18-10.1l-5.7,1.6l29.4,104.6l5.7-1.6C-1832.4,344-1827.8,335.9-1830,328.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061451877644558131250000003981391542357726126_",
    gradientUnits: "userSpaceOnUse",
    x1: -1882.0695,
    y1: 310.2388,
    x2: -1700.0887,
    y2: 310.2388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061451877644558131250000003981391542357726126_)"
    },
    d: "M-1704.6,389.9h-118.6 c-9.1,0-17.2-6.1-19.7-14.9l-39-138.6c-0.7-2.4,0.7-4.9,3.1-5.6c2.4-0.7,4.9,0.7,5.6,3.1l39,138.6c1.4,4.9,5.9,8.4,11,8.4h118.6 c2.5,0,4.5,2,4.5,4.5S-1702.1,389.9-1704.6,389.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "-1679.3,470.7 -1674.5,495.1 -1649.1,491.8 -1654.1,467.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-1672.9,511.5c-2.8,0-5.3-1.8-6.1-4.5c-1.2-4.3-2.4-11-0.1-17c2.3-6.7,10.3,4.6,18.2,3.6 c7.9-1,7.8-8.9,15.3-4.7c7.4,4.1,21.7,12.5,32.7,14.1s6.3,8.6,0.8,8.6H-1672.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M-1677.5,505.9c2.2,1.8,5.3,1.5,8.1,1.6c2.8,0,5.6-0.3,8.4-0.5c5.6-0.4,11.2-0.6,16.9-0.6 c5.6-0.1,11.2,1,16.8,1.5c5.6,0.3,11.2-0.1,16.7-1.1c-5.4,1.4-11.1,2-16.8,1.9c-5.7-0.3-11.1-1.4-16.8-1.2 c-5.6-0.1-11.2,0.1-16.8,0.3c-4.2,0.1-8.5,0.5-12.7-0.2C-1675.1,507.3-1676.5,506.9-1677.5,505.9L-1677.5,505.9z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-1760.2,488.8c-2.6-1.1-5.2-3.2-4.8-6c0.5-4.4,3.2-13.1,7.6-17.8c4.7-5.2,7.7,8.2,15.3,10.4 c7.7,2.1,10.7-5.1,15.9,1.6c5.3,6.7,12.1,21.4,23.2,21.8c9.8,0.3,9,8.9-2.3,9.9C-1726.5,510.4-1760.2,488.8-1760.2,488.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M-1762.1,480.2c1.3,2.5,3.3,4.6,5.8,5.7c2.6,1.1,4.8,2.3,7.5,3.2c5.3,1.8,9.9,3.8,15.1,6 c5.2,2.1,9.8,5.5,14.8,8.1c5,2.5,12.2,3.1,17.7,1.9c-5.5,1.2-12.8,1.1-18-1.2c-5.1-2.5-9.6-5.8-14.9-7.9c-5.1-2.3-9.7-4.3-15-6.2 c-3.9-1.5-8.8-3.5-11.3-6.4C-1761.3,482.4-1761.6,481.6-1762.1,480.2L-1762.1,480.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083797918674342325930000017863247531847728256_",
    gradientUnits: "userSpaceOnUse",
    x1: -1748.7566,
    y1: 307.1084,
    x2: -1728.4088,
    y2: 372.8475
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2564D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083797918674342325930000017863247531847728256_)"
    },
    d: "M-1799.3,364.8l8.3-43.9l101.4,12.9 c12.9,1.6,23,11.7,24.8,24.5l15.8,114.4l-31.8,5.2l-23.7-102.9L-1799.3,364.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049925770067938163700000002335093497901563268_",
    gradientUnits: "userSpaceOnUse",
    x1: -1724.571,
    y1: 403.7809,
    x2: -1700.0493,
    y2: 405.8679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049925770067938163700000002335093497901563268_)"
    },
    d: "M-1713.8,304.5l-16.8,196.6 c-0.2,2.6,1.8,4.8,4.4,4.8l0,0c2.2,0,4-1.6,4.4-3.7l31.5-197.7H-1713.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066478560829050848200000006289331813320573830_",
    gradientUnits: "userSpaceOnUse",
    x1: -1345.9355,
    y1: 399.2914,
    x2: -1376.1964,
    y2: 403.4654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066478560829050848200000006289331813320573830_)"
    },
    d: "M-1360,304.5l16.1,189.7 c0.2,2.5-1.5,4.6-3.5,4.6l0,0c-1.7,0-3.2-1.5-3.5-3.6l-27.8-190.8H-1360z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161603910910629201650000013169977536724366760_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.5803,
    y1: 442.0991,
    x2: 609.0153,
    y2: 442.0991,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161603910910629201650000013169977536724366760_)"
    },
    d: "M-1286.7,503.3c0.2,0,0.4,0,0.7,0 c2.5-0.4,4.2-2.6,3.8-5.1l-16.4-113.5c-0.4-2.5-2.6-4.2-5.1-3.8c-2.5,0.4-4.2,2.6-3.8,5.1l16.4,113.5 C-1290.9,501.7-1288.9,503.3-1286.7,503.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156548543135229269900000014924329893806186931_",
    gradientUnits: "userSpaceOnUse",
    x1: 702.8771,
    y1: 442.0991,
    x2: 728.3122,
    y2: 442.0991,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156548543135229269900000014924329893806186931_)"
    },
    d: "M-1422.5,503.3c2.2,0,4.1-1.6,4.4-3.9 l16.4-113.5c0.4-2.5-1.3-4.7-3.8-5.1c-2.5-0.4-4.7,1.3-5.1,3.8l-16.4,113.5c-0.4,2.5,1.3,4.7,3.8,5.1 C-1422.9,503.3-1422.7,503.3-1422.5,503.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168114535177648502440000002618210987730891686_",
    gradientUnits: "userSpaceOnUse",
    x1: 647.2991,
    y1: 335.9272,
    x2: 657.473,
    y2: 381.8403,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168114535177648502440000002618210987730891686_)"
    },
    d: "M-1395.8,364.8h79.4 c8.1,0,14.6,6.5,14.6,14.6v6h-108.7v-6C-1410.4,371.3-1403.9,364.8-1395.8,364.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033353953144338932790000004013640644403575995_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.0806,
    y1: 243.6135,
    x2: 594.9067,
    y2: 343.7874,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033353953144338932790000004013640644403575995_)"
    },
    d: "M-1292.9,328.2l21.5-76.5 c2.2-7.8,10.3-12.3,18-10.1l5.7,1.6l-29.4,104.6l-5.7-1.6C-1290.6,344-1295.1,335.9-1292.9,328.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111895715518060225580000013877105311408802237_",
    gradientUnits: "userSpaceOnUse",
    x1: 542.1926,
    y1: 310.2388,
    x2: 724.1733,
    y2: 310.2388,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111895715518060225580000013877105311408802237_)"
    },
    d: "M-1418.3,389.9h118.6 c9.1,0,17.2-6.1,19.7-14.9l39-138.6c0.7-2.4-0.7-4.9-3.1-5.6c-2.4-0.7-4.9,0.7-5.6,3.1l-39,138.6c-1.4,4.9-5.9,8.4-11,8.4h-118.6 c-2.5,0-4.5,2-4.5,4.5S-1420.8,389.9-1418.3,389.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "-1722.5,159.5 -1726.7,173.7 -1730.2,185.6 -1762.5,169.7 -1740.4,136.5 -1734.2,144.5  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M-1722.5,159.5l-4.9,16.8c-7.1-8.9-9.1-22.8-10.3-31.9l6.3,1L-1722.5,159.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1739,116l-2.7,10.9c-1.9,7.5-0.4,15.4,4.1,21.9l10.7,15.5c3.8,5.5,12.4,5.6,16.4,0.2l6.1-8.4 c2.9-4,5.2-8.5,6.6-13.2l4.9-16.6c2.4-8-1-16.6-8.4-21.3l-6-3.8c-5.8-3.7-13.4-3.8-19.4-0.3l-1.8,1.1 C-1733.7,105.2-1737.6,110.2-1739,116z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075880371174435966080000007787752448075118512_",
    gradientUnits: "userSpaceOnUse",
    x1: -1746.6158,
    y1: 108.2084,
    x2: -1684.4175,
    y2: 113.5019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075880371174435966080000007787752448075118512_)"
    },
    d: "M-1732.4,123.2 c20.8,7.5,27.6,4.7,30.5,1.4c8,5.1,17,0.6,20-7.4c-0.8-6.3-13.5-21.7-37-21.3c-4.3-6.3-15.5,0.6-20.5,11 C-1744.5,117.1-1738.3,121.1-1732.4,123.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114069897268941844350000013404525202903963326_",
    gradientUnits: "userSpaceOnUse",
    x1: -1706.9692,
    y1: 103.118,
    x2: -1754.1865,
    y2: 123.9876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114069897268941844350000013404525202903963326_)"
    },
    d: "M-1742.5,136.5 c-7.3-17.2-4.4-30.5,1.1-38.6s25.3,10.5,21.7,18.6C-1723.4,124.6-1730.6,141.2-1742.5,136.5z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1730.6,132.8c0,5.9-3.7,10.8-8.2,10.8c-4.5,0-8.2-4.8-8.2-10.8c0-5.9,3.7-10.8,8.2-10.8 C-1734.3,122-1730.6,126.8-1730.6,132.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179617645456854763030000003184164555133370009_",
    gradientUnits: "userSpaceOnUse",
    x1: -1354.0551,
    y1: 405.1631,
    x2: -1313.7542,
    y2: 405.1631
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179617645456854763030000003184164555133370009_)"
    },
    d: "M-1330.6,304.5l16.8,196.6 c0.2,2.6-1.8,4.8-4.4,4.8l0,0c-2.2,0-4-1.6-4.4-3.7l-31.5-197.7H-1330.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000147204137805807781120000001864265499487385493_",
    cx: -1786.8206,
    cy: 213.4367,
    r: 157.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147204137805807781120000001864265499487385493_)"
    },
    d: "M-1729.2,268.9 c-0.8,23.4-0.7,45.3,1.3,59.3c-36.1,37.6-83.3,37.3-83.3,37.3c-9.4-53.2-3-172.4,42.9-198c12.8-2.9,31.6,5,44.1,14.3 c-0.3,4.9-0.7,10.5-1.1,16.5C-1726.7,218.8-1728.4,244.6-1729.2,268.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114789245034586925560000009155528526467642257_",
    gradientUnits: "userSpaceOnUse",
    x1: -1522.1772,
    y1: 274.6107,
    x2: -1522.1772,
    y2: 292.1104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2564D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114789245034586925560000009155528526467642257_)"
    },
    d: "M-1315.8,304.5h-412.7 c-4.8,0-8.7-3.9-8.7-8.7v-15.8h430.2v15.8C-1307.1,300.5-1311,304.5-1315.8,304.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168836705533432418660000004010655216682941318_",
    gradientUnits: "userSpaceOnUse",
    x1: -1522.1772,
    y1: 271.4803,
    x2: -1522.1772,
    y2: 279.3161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8D3E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168836705533432418660000004010655216682941318_)"
    },
    d: "M-1295.2,279.9h-453.9 c-2.7,0-4.8-2.2-4.8-4.8l0,0c0-2.7,2.2-4.8,4.8-4.8h453.9c2.7,0,4.8,2.2,4.8,4.8l0,0C-1290.4,277.7-1292.6,279.9-1295.2,279.9z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1649.7,254.8c0-0.1,3.5,0.9,6.6,1.8c3.2,1,6.6,0.8,9.7-0.3l0.8-0.3c2.1-0.8,4.4-0.7,6.4,0.2l1.2,0.5 c2,0.9,3.8,2.1,5.3,3.6l3.5,3.4c1.2,1.1,1.6,2.9,1.1,4.4v0c-0.4,1.2-1.5,2-2.8,2h-29.4c-4.4,0-8.7-0.6-12.9-1.8l-4-1.1l6.7-13.1 L-1649.7,254.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034775201358542450060000002192630954386161824_",
    gradientUnits: "userSpaceOnUse",
    x1: -1674.9695,
    y1: 305.6836,
    x2: -1650.7086,
    y2: 281.8141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034775201358542450060000002192630954386161824_)"
    },
    d: "M-1579.4,264.3H-1691 c-1.8,0-3.2,1.4-3.2,3.2v2.7h114.8V264.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031177483963984935460000002168773420156480919_",
    gradientUnits: "userSpaceOnUse",
    x1: -1599.5004,
    y1: 274.4657,
    x2: -1587.9569,
    y2: 237.4874
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031177483963984935460000002168773420156480919_)"
    },
    d: "M-1537.1,201h-81.8 c-2.2,0-4.2,1.5-4.8,3.6l-16.7,61.1c-0.6,2.2,1.1,4.4,3.4,4.4h81.1c2.3,0,4.2-1.5,4.8-3.7l16.9-61.7 C-1533.7,202.9-1535.1,201-1537.1,201z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043443648844889731190000014781894335426061227_",
    gradientUnits: "userSpaceOnUse",
    x1: -1644.1506,
    y1: 271.6577,
    x2: -1539.281,
    y2: 210.6143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043443648844889731190000014781894335426061227_)"
    },
    d: "M-1531.9,201h-81.8 c-2.2,0-4.2,1.5-4.8,3.6l-16.7,61.1c-0.6,2.2,1.1,4.4,3.4,4.4h81.1c2.3,0,4.2-1.5,4.8-3.7l16.9-61.7 C-1528.5,202.9-1530,201-1531.9,201z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032641255151008755390000009559059873745237401_",
    gradientUnits: "userSpaceOnUse",
    x1: -1595.3243,
    y1: 244.0634,
    x2: -1581.0417,
    y2: 233.8895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2564D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032641255151008755390000009559059873745237401_)"
    },
    d: "M-1572.6,235.6 c-1.3,6-7.2,10.9-13.2,10.9s-9.8-4.9-8.5-10.9c1.3-6,7.2-10.9,13.2-10.9S-1571.3,229.6-1572.6,235.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131361703452975997130000001033221762989547136_",
    gradientUnits: "userSpaceOnUse",
    x1: -1749.8788,
    y1: 216.3077,
    x2: -1746.7484,
    y2: 250.4816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131361703452975997130000001033221762989547136_)"
    },
    d: "M-1725.3,213.2 c-1.4,20.3-3.1,31.4-3.8,55.7c-14.3-3.3-24.6-12.5-24.8-16.6c-0.3-5.1-9.5-14.5-15.6-18.8c-6.1-4.3-6.8-43-6.8-43L-1725.3,213.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093146724429127511910000008799902327160881079_",
    gradientUnits: "userSpaceOnUse",
    x1: -1719.9468,
    y1: 234.4191,
    x2: -1748.512,
    y2: 273.9409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093146724429127511910000008799902327160881079_)"
    },
    d: "M-1730.6,188.9l13.8,42.8l67.8,21.4 l-6.4,17.1l-65.3-5.6c-10.5-0.9-20-6.3-26.2-14.8l-28.6-49.5C-1782.8,171.6-1737.8,160.3-1730.6,188.9z"
  }), /*#__PURE__*/React.createElement("g", null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1519.7,197.5l-7.1,6c-1.1,0.9-2.4,1.6-3.8,1.9l-1.7,0.4c-4,0.8-7.3,3.6-8.9,7.3l-0.5,1.2 c-1.1,2.6-0.1,5.7,2.3,7.2l0,0c2.6,1.6,5.9,1.9,8.7,0.6l5.9-2.7c2-0.9,3.8-2.1,5.4-3.6l9.2-8.5L-1519.7,197.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072996497311549420670000002968479084503697066_",
    gradientUnits: "userSpaceOnUse",
    x1: -1566.4911,
    y1: 123.2278,
    x2: -1438.9246,
    y2: 172.5327
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072996497311549420670000002968479084503697066_)"
    },
    d: "M-1427.3,107.9l-24.2,59.9 c-3.2,7.8-8.8,14.4-16.1,18.6l-40.1,23.5l-7,4.1l-13.7-13l7.2-6.5l37.7-33.8L-1464,92L-1427.3,107.9z"
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "-1494.8,469.5 -1496.8,495.1 -1472.5,494.9 -1470.2,469.5  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "-1427.9,495.1 -1429.8,469.5 -1405.5,469.7 -1403.2,495.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126298675952814395620000010471413784739223430_",
    gradientUnits: "userSpaceOnUse",
    x1: -1783.3273,
    y1: 451.2303,
    x2: -1176.0228,
    y2: 297.0564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126298675952814395620000010471413784739223430_)"
    },
    d: "M-1483.9,248.4h90.8l2.2,13.5 c2.2,13.3,1.9,27-1,40.2l-1.8,18c-0.8,8.4-1.3,16.8-1.5,25.3l-2.9,134.9l-36.9,0.9l-4.4-189.4l-26.6,189.4h-35.2L-1483.9,248.4z"
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-1474,511.5c2.8,0,5.3-1.8,6.1-4.5c1.2-4.3,2.4-11,0.1-17c-2.3-6.7-10.3,4.6-18.2,3.6 c-7.9-1-7.8-8.9-15.3-4.7c-7.4,4.1-21.7,12.5-32.7,14.1c-11,1.6-6.3,8.6-0.8,8.6H-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M-1469.4,505.9c-2.2,1.8-5.3,1.5-8.1,1.6c-2.8,0-5.6-0.3-8.4-0.5c-5.6-0.4-11.2-0.6-16.9-0.6 c-5.6-0.1-11.2,1-16.8,1.5c-5.6,0.3-11.2-0.1-16.7-1.1c5.4,1.4,11.1,2,16.8,1.9c5.7-0.3,11.1-1.4,16.8-1.2 c5.6-0.1,11.2,0.1,16.8,0.3c4.2,0.1,8.5,0.5,12.7-0.2C-1471.9,507.3-1470.4,506.9-1469.4,505.9L-1469.4,505.9z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-1406.7,511.5c2.8,0,5.3-1.8,6.1-4.5c1.2-4.3,2.4-11,0.1-17c-2.3-6.7-10.3,4.6-18.2,3.6 c-7.9-1-7.8-8.9-15.3-4.7c-7.4,4.1-21.7,12.5-32.7,14.1s-6.3,8.6-0.8,8.6H-1406.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M-1402.1,505.9c-2.2,1.8-5.3,1.5-8.1,1.6c-2.8,0-5.6-0.3-8.4-0.5c-5.6-0.4-11.2-0.6-16.9-0.6 c-5.6-0.1-11.2,1-16.8,1.5c-5.6,0.3-11.2-0.1-16.7-1.1c5.4,1.4,11.1,2,16.8,1.9c5.7-0.3,11.1-1.4,16.8-1.2 c5.6-0.1,11.2,0.1,16.8,0.3c4.2,0.1,8.5,0.5,12.7-0.2C-1404.6,507.3-1403.1,506.9-1402.1,505.9L-1402.1,505.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153673847280083481650000000973656542826661038_",
    gradientUnits: "userSpaceOnUse",
    x1: -1207.9094,
    y1: -58.5909,
    x2: -1441.1284,
    y2: 182.4542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153673847280083481650000000973656542826661038_)"
    },
    d: "M-1389.4,248.4c-32.3,10.2-69.6,9.6-98,0 c0,0,0.9-3.4,2-8.5c1.2-5.5,2.8-12.9,4-19.9c0.1-0.8,0.3-1.6,0.4-2.4c1.4-8.6,3.2-16.9,4.1-26.1c0.9-8.3,1.1-17.3-0.2-27.9 l-7.1-15.1c-2.3-9.7-0.8-19.9,4.1-28.6l23.7-41.2h29.1l17.5,7.7c10.3,4.6,17.3,14.4,18.3,25.6l-1.2,37.2 c-0.2,6.9-0.7,13.7-1.3,20.5l-0.5,5.3l-0.8,7.9l-1.3,13.3c-0.9,9.2-0.8,18.5,0.4,27.8l4.3,15.4L-1389.4,248.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106853136098348523060000012885597185601006248_",
    gradientUnits: "userSpaceOnUse",
    x1: -1483.5244,
    y1: 179.375,
    x2: -1420.9554,
    y2: 215.5524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106853136098348523060000012885597185601006248_)"
    },
    d: "M-1479.3,207.9l24.2-14l44.9-5.8l3.9,7.6 l-56.4,21.1c-3.6,1.4-7.7,1.3-11.2-0.2l0,0l-6.4-2L-1479.3,207.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051348691458445467330000016575426101763876266_",
    gradientUnits: "userSpaceOnUse",
    x1: -1460.6278,
    y1: 120.8022,
    x2: -1402.9673,
    y2: 154.1415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000051348691458445467330000016575426101763876266_)"
    },
    points: "-1428,174.5 -1426.5,165.7  -1440.1,118.2 -1410.3,115.1 -1411.9,174.5  "
  }), /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1468.5,200.1l-6.2-1.8l-1.1-1.3c-2-2.4-5.3-3.5-8.6-2.9l-9.6,1.8c-2.4,0.4-4.1,2.2-4.2,4.4l-0.1,2.2 c-0.2,2.6,1.5,5,4.1,6.1l6.2,1.8c3.1,1.7,6.7,2.5,10.3,2.1l9-2.7L-1468.5,200.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049180129613276614920000014057590329659683752_",
    gradientUnits: "userSpaceOnUse",
    x1: -1316.1071,
    y1: 58.178,
    x2: -1416.6722,
    y2: 149.3519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049180129613276614920000014057590329659683752_)"
    },
    d: "M-1398.9,193.6l-61.6,17.7l-9.7,2.8 l-6.3-19.3l9.3-4.5l46.3-22.6l-17.5-43.3c-9.4-22.3,21.3-38.9,37-26.7c3.7,2.9,6.1,7.2,6.9,11.8l10.5,60.4 C-1382.1,180.4-1388.6,190.7-1398.9,193.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110447833977287202250000002249451441781540240_",
    gradientUnits: "userSpaceOnUse",
    x1: -1334.2084,
    y1: 162.2735,
    x2: -1405.4257,
    y2: 183.4039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000110447833977287202250000002249451441781540240_)"
    },
    points: "-1460.5,211.3 -1470.3,214.1  -1476.5,194.8 -1467.2,190.2  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M-1474.4,67.2c0.6,3.5,3.1,6.3,6.5,7.3c18.9,5.7,41.7,1.4,53.5-2c10.2-3,13.4-24.8,9.4-46.7 c-3.5-19-17.3-29.6-20.1-24.8c-9.6-14.2-39.8-15.7-48,9.4C-1479.5,29.7-1476.2,56.1-1474.4,67.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027570717397901534420000010472121648866189731_",
    gradientUnits: "userSpaceOnUse",
    x1: -1487.386,
    y1: 247.7074,
    x2: -1389.406,
    y2: 247.7074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027570717397901534420000010472121648866189731_)"
    },
    d: "M-1389.4,248.4c-32.3,10.2-69.6,9.6-98,0 c0,0,0.9-3.4,2-8.5c30.9,8.9,62,8.6,93.5-0.3L-1389.4,248.4z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1427.3,78.8l-17,8.6c-3.4,1.7-7.6,0.4-9.3-3.1l-2.8-5.5l0.4-1.6l4.8-20.3l6.3-1.6l16.7-4.3L-1427.3,78.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M-1430.9,59.1c-3.5,7.1-13.6,14.1-25.2,18.2l4.8-20.3l6.3-1.6C-1439.1,56.8-1430.9,59.1-1430.9,59.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1444.7,68.6l-5.9,1.9c-4.7,1.5-9.9-0.6-12.1-5.1l-4-8.1c-2.9-5.9-4.1-12.6-3.3-19.1l1.8-28.8 c0.2-2.7,2.4-4.9,5.2-4.9h33.9c2.8,0,5.1,2.3,5.2,5.1l0.7,30c0,0.6,0,1.3,0,1.9c-0.2,5.1-2.1,10.1-5.2,14.2l-1.8,2.5 C-1433.8,63-1438.9,66.7-1444.7,68.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M-1464.6,22.2c8.5,3.1,26.4-1.4,29.2-5.1c-4.5,11,2.8,23,8.1,25.8c5.3,2.8,8.2-6.2,8.2-6.2 s6.7-30.9-5.3-31.7c-15.1-15.1-31.6-11.2-41-0.7C-1474.7,14.9-1470.5,20-1464.6,22.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1420.7,47.2c-5.3,11.5-14.1,12.1-12.7-1.2s8.7-12.7,12-10.2S-1419.2,44-1420.7,47.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183251276960397655200000010989185887584637625_",
    gradientUnits: "userSpaceOnUse",
    x1: -1529.5525,
    y1: 189.7481,
    x2: -1510.2482,
    y2: 216.3568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183251276960397655200000010989185887584637625_)"
    },
    d: "M-1507.8,210l-7,4.1l-13.7-13l7.2-6.5 C-1516.6,199.9-1510.9,206.4-1507.8,210z"
  })), /*#__PURE__*/React.createElement("g", null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M-1597.5,109.3h-34.8c-9.9,0-18,8.1-18,18v0c0,7,4,13,9.8,16c-0.1,0.1-0.1,0.2-0.2,0.2 c-2.9,3-9.9,4.1-8.6,6.1c1,1.6,10.1,0.5,16.5-2.8c1.9-1,4-1.5,6.2-1.5h29.2c9.9,0,18-8.1,18-18v0 C-1579.5,117.3-1587.6,109.3-1597.5,109.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: -1631.2,
    cy: 128.1,
    r: 5.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097461466925691081040000010484948449079226531_",
    cx: -1637.6865,
    cy: 122.286,
    r: 12.0035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000097461466925691081040000010484948449079226531_)"
    },
    cx: -1632.6,
    cy: 127,
    r: 5.6
  })), /*#__PURE__*/React.createElement("g", null, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: -1613.6,
    cy: 128.1,
    r: 5.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000005247705420564169110000003362965139747668649_",
    cx: -1620.0778,
    cy: 122.286,
    r: 12.0035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000005247705420564169110000003362965139747668649_)"
    },
    cx: -1615,
    cy: 127,
    r: 5.6
  })), /*#__PURE__*/React.createElement("g", null, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: -1596,
    cy: 128.1,
    r: 5.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000160160524121771317610000009882649745509818026_",
    cx: -1602.4691,
    cy: 122.286,
    r: 12.0035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000160160524121771317610000009882649745509818026_)"
    },
    cx: -1597.4,
    cy: 127,
    r: 5.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179634675154815825310000017933675236411741083_",
    gradientUnits: "userSpaceOnUse",
    x1: -1583.582,
    y1: -67.5555,
    x2: -1524.495,
    y2: 18.1401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179634675154815825310000017933675236411741083_)"
    },
    d: "M-1559.5-25.4h34.8c9.9,0,18,8.1,18,18v0 c0,7-4,13-9.8,16c0.1,0.1,0.1,0.2,0.2,0.2c2.9,3,9.9,4.1,8.6,6.1c-1,1.6-10.1,0.5-16.5-2.8c-1.9-1-4-1.5-6.2-1.5h-29.2 c-9.9,0-18-8.1-18-18v0C-1577.5-17.3-1569.4-25.4-1559.5-25.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st111",
    cx: -1525.8,
    cy: -6.6,
    r: 5.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000009576648670848803820000000775256933027738043_",
    cx: 424.9088,
    cy: -12.351,
    r: 12.0035,
    gradientTransform: "matrix(-1 0 0 1 -1094.3976 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000009576648670848803820000000775256933027738043_)"
    },
    cx: -1524.4,
    cy: -7.6,
    r: 5.6
  })), /*#__PURE__*/React.createElement("g", null, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st111",
    cx: -1543.4,
    cy: -6.6,
    r: 5.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127036997939019273760000013456416232779638934_",
    cx: 442.5175,
    cy: -12.351,
    r: 12.0035,
    gradientTransform: "matrix(-1 0 0 1 -1094.3976 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000127036997939019273760000013456416232779638934_)"
    },
    cx: -1542,
    cy: -7.6,
    r: 5.6
  })), /*#__PURE__*/React.createElement("g", null, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st111",
    cx: -1561,
    cy: -6.6,
    r: 5.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000130641042293509393570000005343749521786416539_",
    cx: 460.1262,
    cy: -12.351,
    r: 12.0035,
    gradientTransform: "matrix(-1 0 0 1 -1094.3976 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000130641042293509393570000005343749521786416539_)"
    },
    cx: -1559.6,
    cy: -7.6,
    r: 5.6
  }))))), /*#__PURE__*/React.createElement("g", null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.5,370.7c0,41.7-11.3,67.9-30.9,84.3c-39.4,32.9-112.5,26.2-196.2,26.2S97.6,487.9,58.2,455 c-19.6-16.4-30.9-42.6-30.9-84.3C27.3,245.3,129,61,254.4,61C379.8,61,481.5,245.3,481.5,370.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000060013456440704659680000005818406494132348320_",
    d: "M481.2,370.7c0,41.7-11.3,67.9-30.9,84.3 c-39.4,32.9-112.5,26.2-196.2,26.2S97.3,487.9,58,455c-19.6-16.4-30.9-42.6-30.9-84.3C27.1,245.3,128.7,61,254.1,61 C379.6,61,481.2,245.3,481.2,370.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178178763784062943270000008088766468837485717_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060013456440704659680000005818406494132348320_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 379.8,
    y: 124.6,
    className: "st2",
    width: 64.8,
    height: 100.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 390.8,
    y: 137.2,
    className: "st0",
    width: 42.8,
    height: 77.5
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 9.9,
    y: 454.7,
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#D6EAFF"
    },
    width: 480.7,
    height: 59.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -14.7,
    y: 348.1,
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#BCD9F7"
    },
    width: 543.9,
    height: 100.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -14.7,
    y: 348.1,
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#9CC3ED"
    },
    width: 543.9,
    height: 6.7
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149353553228964074890000006404536486944263842_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.7099,
    y1: 285.2312,
    x2: 427.761,
    y2: 245.1843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149353553228964074890000006404536486944263842_)"
    },
    d: "M405,316.3c-4-28.3,9.3-29.6,4.6-53.3 c-4.8-23.8,4.6-35.4,2.4-45.7c7,13.5,10.6,31,7.6,49.3c-3,18.3,5.8,38,1,48.5L405,316.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141428747230661474280000005352128634659034247_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.6249,
    y1: 303.7358,
    x2: 404.3769,
    y2: 260.4707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4296,
    style: {
      stopColor: "#B5E25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141428747230661474280000005352128634659034247_)"
    },
    d: "M402.2,319.5 c-14.3-35.5-5.8-46.3-2.8-67.8c3-21.5-3-40.3-7.3-47.5c10.5,5.8,24.3,34,18.3,62c-6,28,9.3,42.5,5.3,56.3 S402.2,319.5,402.2,319.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096767914296354783120000004561055093933529497_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.7049,
    y1: 299.5673,
    x2: 386.7018,
    y2: 270.8073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096767914296354783120000004561055093933529497_)"
    },
    d: "M399.7,332.3 c7.4-29.2,1.8-29.9-2.8-46.3c-4.6-16.4-4.2-38.4-1.6-44.5c-7.6,5.6-17.2,38.4-9.6,59.6s-0.7,24.7,3.9,35 C394.1,346.3,399.7,332.3,399.7,332.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165230068539044099040000010054546542331605416_",
    gradientUnits: "userSpaceOnUse",
    x1: -1262.9032,
    y1: 293.9022,
    x2: -1270.226,
    y2: 270.5101,
    gradientTransform: "matrix(-1 0 0 1 -840.494 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165230068539044099040000010054546542331605416_)"
    },
    d: "M419.2,320.5c-6-23.7-1.5-24.3,2.3-37.7 c3.8-13.4,3.4-31.3,1.3-36.2c6.2,4.6,14,31.3,7.8,48.5s0.6,20.1-3.2,28.5S419.2,320.5,419.2,320.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137826410146787880640000009379182092418470059_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.5046,
    y1: 295.5625,
    x2: 392.63,
    y2: 254.6732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137826410146787880640000009379182092418470059_)"
    },
    d: "M395.2,312.3c-1.2-3.8-2.3-7.6-3.3-11.4 c-1-3.8-1.9-7.7-2.7-11.6c-0.7-3.9-1.1-7.9-1.2-11.8c0-1,0-2,0-3l0.1-3l0.3-3l0.4-2.9c-0.4,3.9-0.6,7.9-0.4,11.8 c0.2,3.9,0.6,7.9,1.3,11.7c0.7,3.9,1.6,7.7,2.5,11.6L395.2,312.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159464556791452685870000014619336994898477713_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.1064,
    y1: 296.1571,
    x2: 414.2318,
    y2: 255.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159464556791452685870000014619336994898477713_)"
    },
    d: "M411.3,309.1c0.7-2.8,1.4-5.6,1.8-8.4 c0.3-1.4,0.4-2.9,0.6-4.3c0.1-1.4,0.3-2.9,0.3-4.3c0.2-2.9,0.2-5.7,0.3-8.6c0-2.9-0.1-5.8-0.2-8.6c-0.1-2.9-0.2-5.8-0.2-8.7 c0-1.5,0.1-2.9,0.1-4.3c0.1-1.4,0.2-2.9,0.3-4.3l0.8-8.6c0.2-2.9,0.5-5.7,0.4-8.6c0.1,1.4,0.1,2.9,0.1,4.3c0,1.4-0.1,2.9-0.2,4.3 l-0.6,8.6l-0.3,4.3c-0.1,1.4-0.1,2.9-0.1,4.3c0,2.9,0.2,5.8,0.3,8.6c0.2,5.8,0.2,11.6-0.2,17.3 C414.1,297.9,413.1,303.6,411.3,309.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039856457096550179880000002212186582128243349_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.6984,
    y1: 295.8981,
    x2: 404.8238,
    y2: 255.0088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039856457096550179880000002212186582128243349_)"
    },
    d: "M406,312.1c-1.7-6.5-3.1-13.1-3.9-19.7 c-0.4-3.3-0.6-6.7-0.7-10c-0.1-3.4,0.1-6.7,0.5-10.1c0.4-3.3,1-6.6,1.7-9.9c0.2-0.8,0.3-1.6,0.5-2.5l0.2-1.2l0.1-1.2 c0.1-0.8,0.2-1.7,0.2-2.5c0.1-0.8,0.1-1.7,0.2-2.5c0.2-3.3,0.1-6.7,0-10c-0.1-3.3-0.3-6.7-0.6-10c0.8,6.6,1.3,13.3,1.1,20.1 c-0.1,3.4-0.5,6.7-1.1,10c-0.7,3.3-1.3,6.6-1.7,9.9c-0.4,3.3-0.6,6.6-0.5,10c0.1,3.3,0.3,6.7,0.6,10c0.2,1.7,0.4,3.3,0.6,5l0.8,5 c0.3,1.6,0.6,3.3,0.9,4.9L406,312.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158712355897769465410000001459301888202209665_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.7034,
    y1: 296.3661,
    x2: 421.8288,
    y2: 255.4768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158712355897769465410000001459301888202209665_)"
    },
    d: "M413.4,312.3l3.6-5.1 c1.2-1.7,2.4-3.4,3.5-5.2c1.1-1.8,2.1-3.6,2.9-5.5c0.4-1,0.8-1.9,1.2-2.9l0.5-1.5l0.2-0.7l0.2-0.8c1.1-4,1.7-8.2,2-12.3l0.2-3.1 c0-1,0.1-2.1,0.1-3.1c0.1-2.1,0-4.2,0.1-6.3c0.2,4.2,0.4,8.4,0.2,12.6c-0.2,4.2-0.8,8.4-1.9,12.5l-0.2,0.8l-0.3,0.8l-0.5,1.5 c-0.4,1-0.8,2-1.2,2.9c-0.9,1.9-1.9,3.8-3,5.5C418.7,305.7,416.1,309,413.4,312.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033330266049000889920000014106085560958848700_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.3985,
    y1: 327.5703,
    x2: 447.0773,
    y2: 351.5788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8D3E8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000033330266049000889920000014106085560958848700_)"
    },
    points: "432.9,303 383.7,303  386.2,348.1 429.7,348.1  "
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M433.4,307.4h-50.3c-2.1,0-3.8-1.7-3.8-3.8l0,0c0-2.1,1.7-3.8,3.8-3.8h50.3c2.1,0,3.8,1.7,3.8,3.8l0,0 C437.2,305.8,435.5,307.4,433.4,307.4z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 77.4,
    y: 448.5,
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#95BBE3"
    },
    width: 33.3,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 448.5,
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#95BBE3"
    },
    width: 33.3,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.3,
    y: 448.5,
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#95BBE3"
    },
    width: 33.3,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.3,
    y: 448.5,
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#95BBE3"
    },
    width: 33.3,
    height: 6.2
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.6,389.3H61.1c-1.1,0-2-0.9-2-2v-22c0-1.1,0.9-2,2-2h113.5c1.1,0,2,0.9,2,2v22 C176.6,388.4,175.7,389.3,174.6,389.3z"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 117.9,
    cy: 376.3,
    r: 5.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423,389.3H309.5c-1.1,0-2-0.9-2-2v-22c0-1.1,0.9-2,2-2H423c1.1,0,2,0.9,2,2v22 C425,388.4,424.1,389.3,423,389.3z"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 366.2,
    cy: 376.3,
    r: 5.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423,420.8H309.5c-1.1,0-2-0.9-2-2v-22c0-1.1,0.9-2,2-2H423c1.1,0,2,0.9,2,2v22 C425,419.9,424.1,420.8,423,420.8z"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 366.2,
    cy: 407.8,
    r: 5.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.6,440.5H61.1c-1.1,0-2-0.9-2-2v-41.7c0-1.1,0.9-2,2-2h113.5c1.1,0,2,0.9,2,2v41.7 C176.6,439.6,175.7,440.5,174.6,440.5z"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#9CC3ED"
    },
    cx: 117.9,
    cy: 407.8,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#9CC3ED"
    },
    d: "M422,425.6H310.2 c-1.7,0-3,1.4-3,3v19.9H425v-19.9C425,427,423.6,425.6,422,425.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#ACCFF2"
    },
    d: "M300,439.5H183.4 c-0.6,0-1.2-0.5-1.2-1.2v-74c0-0.6,0.5-1.2,1.2-1.2H300c0.6,0,1.2,0.5,1.2,1.2v74C301.1,439,300.6,439.5,300,439.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#ACCFF2"
    },
    d: "M548.1,439.5H431.5 c-0.6,0-1.2-0.5-1.2-1.2v-74c0-0.6,0.5-1.2,1.2-1.2h116.6c0.6,0,1.2,0.5,1.2,1.2v74C549.2,439,548.7,439.5,548.1,439.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)",
      fill: "#ACCFF2"
    },
    d: "M51.8,439.5H-64.8 c-0.6,0-1.2-0.5-1.2-1.2v-74c0-0.6,0.5-1.2,1.2-1.2H51.8c0.6,0,1.2,0.5,1.2,1.2v74C53,439,52.4,439.5,51.8,439.5z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 41.7,
    className: "st19",
    width: 158.2,
    height: 288.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 184.5,
    y: 49.9,
    className: "st20",
    width: 139.4,
    height: 272
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 184.5,
    y: 180.2,
    className: "st19",
    width: 139.4,
    height: 11.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 184.5,
    y: 191.6,
    className: "st21",
    width: 139.4,
    height: 4.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 116.6,
    y: 178.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 438.3933 -69.8952)",
    className: "st19",
    width: 275.1,
    height: 11.5
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062181412096198005090000006987876289036133507_",
    x: 184.5,
    y: 49.9,
    width: 139.4,
    height: 272
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152981005534173228910000002363149209541970578_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062181412096198005090000006987876289036133507_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054945057596188400380000013408559981026664889_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.7831,
    y1: 99.7359,
    x2: 334.1173,
    y2: 126.7454
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F6F9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000152981005534173228910000002363149209541970578_)",
      fill: "url(#SVGID_00000054945057596188400380000013408559981026664889_)"
    },
    d: " M278.6,116.8c8-20.1,22-24.2,33-13.2s20.5-2.9,33-0.4c12.5,2.5,13.7,13.6,43.4,13.6H278.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031921565034638067010000004279451133441162916_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.5344,
    y1: 142.7403,
    x2: 207.9494,
    y2: 159.1138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F6F9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000152981005534173228910000002363149209541970578_)",
      fill: "url(#SVGID_00000031921565034638067010000004279451133441162916_)"
    },
    d: " M178.6,153.4c4.2-12.8,11.6-15.5,17.4-8.4c5.8,7.1,10.8-1.9,17.4-0.3c6.6,1.6,7.2,8.7,22.9,8.7H178.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182494531650144804930000018088485951769327032_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.5569,
    y1: 492.9892,
    x2: 185.4995,
    y2: 492.9892,
    gradientTransform: "matrix(0.9959 -9.093526e-02 9.093526e-02 0.9959 -34.33 -59.3004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182494531650144804930000018088485951769327032_)"
    },
    d: "M190.4,391l-5.7,0.5 c-1.4,0.1-2.5,1.4-2.4,2.9l3.9,42.7c0.1,1.4,1.4,2.5,2.9,2.4l5.7-0.5c1.4-0.1,2.5-1.4,2.4-2.9l-3.9-42.7 C193.1,392,191.9,390.9,190.4,391z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165218186118842321520000003490674575140741305_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.8741,
    y1: 474.2813,
    x2: 176.8695,
    y2: 475.1149,
    gradientTransform: "matrix(0.9959 -9.093526e-02 9.093526e-02 0.9959 -34.33 -59.3004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000165218186118842321520000003490674575140741305_)"
    },
    points: "193.7,397.8 182.8,398.8  182.6,396.8 193.5,395.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070097321966595570420000011340752369221842317_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.8741,
    y1: 510.3772,
    x2: 176.8695,
    y2: 511.2109,
    gradientTransform: "matrix(0.9959 -9.093526e-02 9.093526e-02 0.9959 -34.33 -59.3004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000070097321966595570420000011340752369221842317_)"
    },
    points: "197,433.7 186.1,434.7  185.9,432.7 196.8,431.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039096589912293993300000015637955868059638402_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.451,
    y1: 491.9471,
    x2: 178.8897,
    y2: 492.2395,
    gradientTransform: "matrix(0.9959 -9.093526e-02 9.093526e-02 0.9959 -34.33 -59.3004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039096589912293993300000015637955868059638402_)"
    },
    d: "M191.1,426l-0.8,0.1 c-0.5,0-0.9-0.3-0.9-0.8l-2-21.4c0-0.5,0.3-0.9,0.8-0.9l0.8-0.1c0.5,0,0.9,0.3,0.9,0.8l2,21.4C191.9,425.5,191.6,425.9,191.1,426 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068654968589927907500000008628843950596006571_",
    gradientUnits: "userSpaceOnUse",
    x1: -496.6721,
    y1: -498.8055,
    x2: -485.7295,
    y2: -498.8055,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068654968589927907500000008628843950596006571_)"
    },
    d: "M297.2,436.7l0-5.7 c0-1.5-1.2-2.6-2.6-2.6l-42.9,0.2c-1.5,0-2.6,1.2-2.6,2.6l0,5.7c0,1.5,1.2,2.6,2.6,2.6l42.9-0.2 C296,439.3,297.2,438.1,297.2,436.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009589134014982061690000003847950625524106908_",
    gradientUnits: "userSpaceOnUse",
    x1: -481.3549,
    y1: -517.5134,
    x2: -494.3595,
    y2: -516.6797,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000009589134014982061690000003847950625524106908_)"
    },
    points: "290.2,439.3 290.1,428.4  292.1,428.4 292.2,439.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004528735096727365540000010025831039153906838_",
    gradientUnits: "userSpaceOnUse",
    x1: -481.3549,
    y1: -481.4174,
    x2: -494.3595,
    y2: -480.5838,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000004528735096727365540000010025831039153906838_)"
    },
    points: "254.1,439.4 254,428.5  256,428.5 256.1,439.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050657198241006049540000017847363209177740929_",
    gradientUnits: "userSpaceOnUse",
    x1: -487.778,
    y1: -499.8476,
    x2: -492.3393,
    y2: -499.5552,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050657198241006049540000017847363209177740929_)"
    },
    d: "M262.3,434.3l0-0.8 c0-0.5,0.4-0.8,0.8-0.8l21.5-0.1c0.5,0,0.8,0.4,0.8,0.8l0,0.8c0,0.5-0.4,0.8-0.8,0.8l-21.5,0.1 C262.7,435.2,262.3,434.8,262.3,434.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147187037604379092270000011838558277342339511_",
    gradientUnits: "userSpaceOnUse",
    x1: -507.4407,
    y1: -494.5917,
    x2: -496.4981,
    y2: -494.5917,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147187037604379092270000011838558277342339511_)"
    },
    d: "M292.9,425.9l0-5.7 c0-1.5-1.2-2.6-2.6-2.6l-42.9,0.2c-1.5,0-2.6,1.2-2.6,2.6l0,5.7c0,1.5,1.2,2.6,2.6,2.6l42.9-0.2 C291.7,428.5,292.9,427.4,292.9,425.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072970110364249908400000010569257650330194105_",
    gradientUnits: "userSpaceOnUse",
    x1: -492.1235,
    y1: -513.2996,
    x2: -505.1281,
    y2: -512.466,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000072970110364249908400000010569257650330194105_)"
    },
    points: "285.9,428.6 285.9,417.6  287.9,417.6 287.9,428.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021842224113996146530000002415638310124254595_",
    gradientUnits: "userSpaceOnUse",
    x1: -492.1235,
    y1: -477.2037,
    x2: -505.1281,
    y2: -476.37,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000021842224113996146530000002415638310124254595_)"
    },
    points: "249.8,428.7 249.8,417.7  251.8,417.7 251.8,428.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167380288608834603880000014671280040713119883_",
    gradientUnits: "userSpaceOnUse",
    x1: -498.5466,
    y1: -495.6338,
    x2: -503.1079,
    y2: -495.3414,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167380288608834603880000014671280040713119883_)"
    },
    d: "M258,423.6l0-0.8c0-0.5,0.4-0.8,0.8-0.8 l21.5-0.1c0.5,0,0.8,0.4,0.8,0.8l0,0.8c0,0.5-0.4,0.8-0.8,0.8l-21.5,0.1C258.4,424.4,258,424,258,423.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126306164138980596910000017326983254163456128_",
    gradientUnits: "userSpaceOnUse",
    x1: -518.4283,
    y1: -499.2569,
    x2: -507.4857,
    y2: -499.2569,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126306164138980596910000017326983254163456128_)"
    },
    d: "M297.5,414.9l0-5.7 c0-1.5-1.2-2.6-2.6-2.6l-42.9,0.2c-1.5,0-2.6,1.2-2.6,2.6l0,5.7c0,1.5,1.2,2.6,2.6,2.6l42.9-0.2 C296.4,417.5,297.5,416.4,297.5,414.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074422662579218417770000007624757138949781391_",
    gradientUnits: "userSpaceOnUse",
    x1: -503.1111,
    y1: -517.9648,
    x2: -516.1157,
    y2: -517.1312,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000074422662579218417770000007624757138949781391_)"
    },
    points: "290.5,417.6 290.5,406.6  292.5,406.6 292.5,417.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183968231372705194480000010240694498946008225_",
    gradientUnits: "userSpaceOnUse",
    x1: -503.1111,
    y1: -481.8688,
    x2: -516.1157,
    y2: -481.0352,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183968231372705194480000010240694498946008225_)"
    },
    points: "254.4,417.7 254.4,406.7  256.4,406.7 256.4,417.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122001094795372672590000003315168317251143334_",
    gradientUnits: "userSpaceOnUse",
    x1: -509.5342,
    y1: -500.299,
    x2: -514.0955,
    y2: -500.0066,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122001094795372672590000003315168317251143334_)"
    },
    d: "M262.7,412.6l0-0.8 c0-0.5,0.4-0.8,0.8-0.8l21.5-0.1c0.5,0,0.8,0.4,0.8,0.8l0,0.8c0,0.5-0.4,0.8-0.8,0.8l-21.5,0.1C263,413.4,262.7,413,262.7,412.6z "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158743330129226475200000011388028018840898749_",
    gradientUnits: "userSpaceOnUse",
    x1: -588.6254,
    y1: -316.5284,
    x2: -577.6828,
    y2: -316.5284,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158743330129226475200000011388028018840898749_)"
    },
    d: "M114.6,345.4l0-5.7 c0-1.5-1.2-2.6-2.6-2.6L69,337.2c-1.5,0-2.6,1.2-2.6,2.6l0,5.7c0,1.5,1.2,2.6,2.6,2.6l42.9-0.2 C113.4,348,114.6,346.8,114.6,345.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109751259834031165610000000221270995125488784_",
    gradientUnits: "userSpaceOnUse",
    x1: -573.3082,
    y1: -335.2364,
    x2: -586.3128,
    y2: -334.4028,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109751259834031165610000000221270995125488784_)"
    },
    points: "107.6,348 107.5,337.1  109.5,337.1 109.6,348  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173845174256496955590000005928100142580669578_",
    gradientUnits: "userSpaceOnUse",
    x1: -573.3082,
    y1: -299.1404,
    x2: -586.3128,
    y2: -298.3068,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000173845174256496955590000005928100142580669578_)"
    },
    points: "71.5,348.1 71.4,337.2  73.4,337.2 73.5,348.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112604806245712405520000002012966103483445686_",
    gradientUnits: "userSpaceOnUse",
    x1: -579.7313,
    y1: -317.5706,
    x2: -584.2926,
    y2: -317.2782,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112604806245712405520000002012966103483445686_)"
    },
    d: "M79.7,343l0-0.8c0-0.5,0.4-0.8,0.8-0.8 l21.5-0.1c0.5,0,0.8,0.4,0.8,0.8l0,0.8c0,0.5-0.4,0.8-0.8,0.8l-21.5,0.1C80.1,343.8,79.7,343.5,79.7,343z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005952735944701607370000004459265946783235219_",
    gradientUnits: "userSpaceOnUse",
    x1: -599.3835,
    y1: -315.3157,
    x2: -588.4409,
    y2: -315.3157,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005952735944701607370000004459265946783235219_)"
    },
    d: "M113.3,334.6l0-5.7 c0-1.5-1.2-2.6-2.6-2.6l-42.9,0.2c-1.5,0-2.6,1.2-2.6,2.6l0,5.7c0,1.5,1.2,2.6,2.6,2.6l42.9-0.2 C112.1,337.2,113.3,336.1,113.3,334.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119812714639877224320000006950102881839082121_",
    gradientUnits: "userSpaceOnUse",
    x1: -584.0663,
    y1: -334.0237,
    x2: -597.0709,
    y2: -333.19,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000119812714639877224320000006950102881839082121_)"
    },
    points: "106.3,337.3 106.3,326.3  108.3,326.3 108.3,337.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076589480364870664710000012071319067756651706_",
    gradientUnits: "userSpaceOnUse",
    x1: -584.0663,
    y1: -297.9277,
    x2: -597.0709,
    y2: -297.0941,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000076589480364870664710000012071319067756651706_)"
    },
    points: "70.2,337.4 70.2,326.4  72.2,326.4 72.2,337.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158014616812170350780000010977712234003668644_",
    gradientUnits: "userSpaceOnUse",
    x1: -590.4894,
    y1: -316.3578,
    x2: -595.0507,
    y2: -316.0655,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158014616812170350780000010977712234003668644_)"
    },
    d: "M78.4,332.3l0-0.8 c0-0.5,0.4-0.8,0.8-0.8l21.5-0.1c0.5,0,0.8,0.4,0.8,0.8l0,0.8c0,0.5-0.4,0.8-0.8,0.8l-21.5,0.1C78.8,333.1,78.4,332.7,78.4,332.3 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070096407798250108950000010752226650133376917_",
    gradientUnits: "userSpaceOnUse",
    x1: -610.3816,
    y1: -316.9799,
    x2: -599.439,
    y2: -316.9799,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070096407798250108950000010752226650133376917_)"
    },
    d: "M114.9,323.6l0-5.7 c0-1.5-1.2-2.6-2.6-2.6l-42.9,0.2c-1.5,0-2.6,1.2-2.6,2.6l0,5.7c0,1.5,1.2,2.6,2.6,2.6l42.9-0.2 C113.8,326.2,114.9,325,114.9,323.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099632318547273928270000009903621763389332124_",
    gradientUnits: "userSpaceOnUse",
    x1: -595.0644,
    y1: -335.6878,
    x2: -608.069,
    y2: -334.8542,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000099632318547273928270000009903621763389332124_)"
    },
    points: "107.9,326.2 107.9,315.3  109.9,315.3 109.9,326.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136413220756187191530000012779903282011452323_",
    gradientUnits: "userSpaceOnUse",
    x1: -595.0644,
    y1: -299.5918,
    x2: -608.069,
    y2: -298.7582,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000136413220756187191530000012779903282011452323_)"
    },
    points: "71.8,326.4 71.8,315.4  73.8,315.4 73.8,326.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118374173719117997700000000778469686264562597_",
    gradientUnits: "userSpaceOnUse",
    x1: -601.4875,
    y1: -318.022,
    x2: -606.0488,
    y2: -317.7296,
    gradientTransform: "matrix(3.505963e-03 1 -1 3.505963e-03 -224.0186 926.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118374173719117997700000000778469686264562597_)"
    },
    d: "M80.1,321.3l0-0.8 c0-0.5,0.4-0.8,0.8-0.8l21.5-0.1c0.5,0,0.8,0.4,0.8,0.8l0,0.8c0,0.5-0.4,0.8-0.8,0.8l-21.5,0.1C80.4,322.1,80.1,321.7,80.1,321.3 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092431687575946594250000003344669038672175021_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.8152,
    y1: 620.7251,
    x2: 167.7578,
    y2: 620.7251,
    gradientTransform: "matrix(0.9705 -0.2409 0.2409 0.9705 -103.0557 -148.0743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092431687575946594250000003344669038672175021_)"
    },
    d: "M200.9,391.2l-5.5,1.4 c-1.4,0.3-2.3,1.8-1.9,3.2l10.3,41.6c0.3,1.4,1.8,2.3,3.2,1.9l5.5-1.4c1.4-0.3,2.3-1.8,1.9-3.2l-10.3-41.6 C203.8,391.7,202.4,390.9,200.9,391.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155123257027306637560000011917537460498849714_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.1324,
    y1: 602.0172,
    x2: 159.1278,
    y2: 602.8508,
    gradientTransform: "matrix(0.9705 -0.2409 0.2409 0.9705 -103.0557 -148.0743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000155123257027306637560000011917537460498849714_)"
    },
    points: "205.2,397.4 194.6,400  194.1,398.1 204.7,395.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065044853680861085500000009497747883343055015_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.1324,
    y1: 638.1131,
    x2: 159.1278,
    y2: 638.9467,
    gradientTransform: "matrix(0.9705 -0.2409 0.2409 0.9705 -103.0557 -148.0743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065044853680861085500000009497747883343055015_)"
    },
    points: "213.9,432.4 203.3,435.1  202.8,433.1 213.4,430.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026871869135065218540000008505722203256451730_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.7093,
    y1: 619.6829,
    x2: 161.148,
    y2: 619.9753,
    gradientTransform: "matrix(0.9705 -0.2409 0.2409 0.9705 -103.0557 -148.0743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026871869135065218540000008505722203256451730_)"
    },
    d: "M207,425.6l-0.8,0.2 c-0.4,0.1-0.9-0.2-1-0.6l-5.2-20.9c-0.1-0.4,0.2-0.9,0.6-1l0.8-0.2c0.4-0.1,0.9,0.2,1,0.6l5.2,20.9 C207.7,425.1,207.4,425.5,207,425.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135686203249352445600000010866770944808154250_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.6357,
    y1: 741.8085,
    x2: 132.5784,
    y2: 741.8085,
    gradientTransform: "matrix(0.9237 -0.3831 0.3831 0.9237 -182.8316 -220.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DABDB",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135686203249352445600000010866770944808154250_)"
    },
    d: "M212.2,392.4l-5.3,2.2 c-1.3,0.6-2,2.1-1.4,3.4l16.4,39.6c0.6,1.3,2.1,2,3.4,1.4l5.3-2.2c1.3-0.6,2-2.1,1.4-3.4l-16.4-39.6 C215.1,392.5,213.5,391.9,212.2,392.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182497300822335555210000005162849497447591082_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.9529,
    y1: 723.1006,
    x2: 123.9484,
    y2: 723.9342,
    gradientTransform: "matrix(0.9237 -0.3831 0.3831 0.9237 -182.8316 -220.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000182497300822335555210000005162849497447591082_)"
    },
    points: "217.3,397.9 207.2,402.1  206.4,400.3 216.5,396.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180350097375057602970000001612661174551345595_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.9529,
    y1: 759.1965,
    x2: 123.9484,
    y2: 760.0302,
    gradientTransform: "matrix(0.9237 -0.3831 0.3831 0.9237 -182.8316 -220.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000180350097375057602970000001612661174551345595_)"
    },
    points: "231.1,431.2 221,435.4  220.2,433.6 230.3,429.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101071794481923290240000017982958766282872760_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.5298,
    y1: 740.7664,
    x2: 125.9686,
    y2: 741.0588,
    gradientTransform: "matrix(0.9237 -0.3831 0.3831 0.9237 -182.8316 -220.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5F2FF",
      stopOpacity: 0.9551
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101071794481923290240000017982958766282872760_)"
    },
    d: "M223.3,425.6l-0.8,0.3 c-0.4,0.2-0.9,0-1.1-0.5l-8.2-19.9c-0.2-0.4,0-0.9,0.5-1.1l0.8-0.3c0.4-0.2,0.9,0,1.1,0.5l8.2,19.9 C223.9,424.9,223.7,425.4,223.3,425.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178178763784062943270000008088766468837485717_)"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103,199.2L103,199.2c-2.1,0-3.7-1.7-3.7-3.7v0c0-2.1,1.7-3.7,3.7-3.7h0c2.1,0,3.7,1.7,3.7,3.7v0 C106.7,197.5,105.1,199.2,103,199.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.5,235.8L127.5,235.8c-2.1,0-3.7-1.7-3.7-3.7l0,0c0-2.1,1.7-3.7,3.7-3.7h0c2.1,0,3.7,1.7,3.7,3.7l0,0 C131.2,234.1,129.6,235.8,127.5,235.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.7,199.2h-8.5c-2.1,0-3.7-1.7-3.7-3.7l0,0c0-2.1,1.7-3.7,3.7-3.7h8.5c2.1,0,3.7,1.7,3.7,3.7l0,0 C124.4,197.5,122.8,199.2,120.7,199.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.5,208.3h-6.2c-2.1,0-3.7-1.7-3.7-3.7l0,0c0-2.1,1.7-3.7,3.7-3.7h6.2c2.1,0,3.7,1.7,3.7,3.7l0,0 C131.2,206.6,129.6,208.3,127.5,208.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.6,217.5h19.9c2.1,0,3.7-1.7,3.7-3.7v0c0-2.1-1.7-3.7-3.7-3.7h-19.9c-2.1,0-3.7,1.7-3.7,3.7v0 C103.9,215.8,105.5,217.5,107.6,217.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117,226.6h10.5c2.1,0,3.7-1.7,3.7-3.7l0,0c0-2.1-1.7-3.7-3.7-3.7H117c-2.1,0-3.7,1.7-3.7,3.7l0,0 C113.3,225,115,226.6,117,226.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.9,226.6h6.2c2.1,0,3.7-1.7,3.7-3.7l0,0c0-2.1-1.7-3.7-3.7-3.7h-6.2c-2.1,0-3.7,1.7-3.7,3.7l0,0 C93.1,225,94.8,226.6,96.9,226.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.2,235.8h6.1c2.1,0,3.7-1.7,3.7-3.7l0,0c0-2.1-1.7-3.7-3.7-3.7h-6.1c-2.1,0-3.7,1.7-3.7,3.7l0,0 C105.4,234.1,107.1,235.8,109.2,235.8z"
  })))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "156.1,438.2 149.9,450.5 139.6,445 147,431.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121967817049078882490000000236894838818387339_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.1221,
    y1: 397.5219,
    x2: 186.459,
    y2: 399.5226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121967817049078882490000000236894838818387339_)"
    },
    d: "M185.7,337.6l-10.3,121.3 c-0.1,1.6,0.9,3,2.3,3l0,0c1.1,0,2.1-1,2.2-2.3l17.8-121.9H185.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056396589144937698150000010036856423652666021_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.9117,
    y1: 479.5089,
    x2: 85.4021,
    y2: 470.2126,
    gradientTransform: "matrix(0.9898 -0.1426 0.1426 0.9898 -58.8828 -48.8761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8FC227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4296,
    style: {
      stopColor: "#B5E25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056396589144937698150000010036856423652666021_)"
    },
    d: "M74.9,433.2c-2-9.1,1.4-9.1,4.6-12.4 c3.2-3.3-2.3-9.2-1.4-12.2c0.9-3,4.4-3.5,3.2-9s2.4-6.8,5-6.7c2.6,0.1,8.3,4.4,4.6,9.1c-3.7,4.8,2.1,7.8-0.5,12.7 c-2.6,4.9,4.5,10.5,0.5,14.6C86.9,433.3,76.3,439.7,74.9,433.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026125434010039031200000001301747015891316368_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.7004,
    y1: 416.3693,
    x2: 50.0244,
    y2: 403.0778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8FC227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4296,
    style: {
      stopColor: "#B5E25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026125434010039031200000001301747015891316368_)"
    },
    d: "M58.8,431.1c1.8-12.4-4.6-13.6,0-20.5 c4.6-6.9-0.7-7.1,0.8-11.8c1.5-4.7,6.5-7.8,7.5-0.3c1,7.5,4.8,7.8,3.3,13.7c-1.5,5.9,4.3,17-1.8,20 C62.5,435.2,58.1,436.1,58.8,431.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060021589458383168200000012613084483174885508_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.1379,
    y1: 436.3543,
    x2: 74.6917,
    y2: 403.4024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A6DD37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4296,
    style: {
      stopColor: "#B5E25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E88E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060021589458383168200000012613084483174885508_)"
    },
    d: "M65.3,441.9 c-7.4-12.3-5.9-22.2-1.3-27.7s6.4-12.3,3.3-20.7c-3.1-8.3-0.3-20.4,7-20.4s10.7,8.6,7.2,20.6s-1.3,13.7,3,20.5s6,22,0,27.7H65.3z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091007360257877225960000014199033422915925439_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.9634,
    y1: 425.9306,
    x2: 74.4866,
    y2: 391.0405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56731D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7D481"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091007360257877225960000014199033422915925439_)"
    },
    d: "M75.2,420.4c0.1-2,0.1-4,0-6 c-0.1-2.3-0.4-4.5-0.6-6.7c0.6-0.2,1-0.6,1.4-1c0.5-0.5,0.9-1,1.3-1.5c-0.8,0.8-1.7,1.6-2.8,1.9c-0.1-2-0.2-4,0.1-6.1 c0.3-3.3,1.1-6.6,1.4-9.9c1.1-0.5,1.7-1.6,2.3-2.6c-0.6,0.7-1.4,1.5-2.3,1.8c0-0.9,0-1.9,0-2.8c-0.3-2.3-0.9-4.5-1.8-6.5 c0.8,2.1,1.3,4.3,1.4,6.6c0.2,2.2-0.2,4.5-0.6,6.7c-0.2,1.2-0.4,2.3-0.6,3.5c-0.6-0.1-1.1-0.3-1.6-0.7c-0.6-0.4-1.1-1-1.5-1.6 c0.6,1.3,1.6,2.5,3,2.9c-0.5,3.1-0.8,6.2-0.4,9.4c0.3,1.9,0.5,3.9,0.6,5.8c-1.7-0.3-3.7-0.9-4.2-2.7c0.3,2,2.5,2.9,4.3,3.4 c0.3,6.8-0.3,13.7-1.2,20.4c0.8-4.5,1.5-9,1.8-13.6c1.1-0.2,2.2-0.6,3.1-1.3c1-0.7,1.8-1.6,2.3-2.6 C79.5,419.1,77.4,420.2,75.2,420.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152265618931195247860000016618768721599106721_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.5623,
    y1: 438.4921,
    x2: 103.3295,
    y2: 456.3309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8D3E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152265618931195247860000016618768721599106721_)"
    },
    d: "M93.3,420.6H55.9l1.8,31.5 c0.1,1.5,1.4,2.7,2.9,2.7h27.5c1.5,0,2.8-1.2,2.9-2.7L93.3,420.6z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M93.7,424H55.5c-1.6,0-2.9-1.3-2.9-2.9v0c0-1.6,1.3-2.9,2.9-2.9h38.1c1.6,0,2.9,1.3,2.9,2.9v0 C96.5,422.7,95.2,424,93.7,424z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009558873071684669010000014207844460662376374_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.23,
    y1: 372.4932,
    x2: 131.222,
    y2: 402.1702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2564D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000009558873071684669010000014207844460662376374_)"
    },
    points: "142.9,434.5 156.1,441.8  197.6,382.8 178.9,358.5 117.5,348.1 112.2,376.2 164.9,386.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087397034591135449230000014133467681952344742_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.7608,
    y1: 425.59,
    x2: 102.0167,
    y2: 425.59
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087397034591135449230000014133467681952344742_)"
    },
    d: "M88.6,464.7c-0.1,0-0.3,0-0.4,0 c-1.6-0.2-2.7-1.7-2.4-3.3l10.5-72.5c0.2-1.6,1.7-2.7,3.3-2.4c1.6,0.2,2.7,1.7,2.4,3.3l-10.5,72.5 C91.3,463.7,90,464.7,88.6,464.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062883244268571513770000015321663090789569185_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.005,
    y1: 425.59,
    x2: 178.2608,
    y2: 425.59
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062883244268571513770000015321663090789569185_)"
    },
    d: "M175.4,464.7c-1.4,0-2.6-1-2.8-2.5 L162,389.7c-0.2-1.6,0.9-3,2.4-3.3c1.6-0.2,3,0.9,3.3,2.4l10.5,72.5c0.2,1.6-0.9,3-2.4,3.3C175.7,464.7,175.5,464.7,175.4,464.7z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057841723563415814500000011838082296556112794_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.4843,
    y1: 357.7342,
    x2: 132.9866,
    y2: 387.0778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057841723563415814500000011838082296556112794_)"
    },
    d: "M158.3,376.2h-50.8 c-5.2,0-9.3,4.2-9.3,9.3v3.8h69.5v-3.8C167.7,380.4,163.5,376.2,158.3,376.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003799007165852442080000003826010468305514644_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.9899,
    y1: 298.7354,
    x2: 92.9997,
    y2: 362.7578
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003799007165852442080000003826010468305514644_)"
    },
    d: "M92.6,352.8l-13.7-48.9 c-1.4-5-6.6-7.9-11.5-6.5l-3.7,1l18.8,66.9l3.7-1C91.1,362.9,94,357.7,92.6,352.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163794263861604962830000000548498293954327214_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.3094,
    y1: 341.3164,
    x2: 175.6156,
    y2: 341.3164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163794263861604962830000000548498293954327214_)"
    },
    d: "M172.7,392.2H96.9 c-5.8,0-11-3.9-12.6-9.5l-24.9-88.6c-0.4-1.5,0.5-3.1,2-3.5c1.5-0.4,3.1,0.5,3.5,2l24.9,88.6c0.9,3.1,3.8,5.3,7.1,5.3h75.8 c1.6,0,2.9,1.3,2.9,2.9S174.3,392.2,172.7,392.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "188.9,443.8 192,459.5 208.2,457.3 205,441.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M193,470c-1.8,0-3.4-1.2-3.9-2.9c-0.8-2.8-1.5-7-0.1-10.8c1.5-4.3,6.6,2.9,11.6,2.3c5-0.7,5-5.7,9.8-3 c4.8,2.6,13.9,8,20.9,9c7,1,4,5.5,0.5,5.5H193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M190,466.3c1.4,1.2,3.4,1,5.1,1c1.8,0,3.6-0.2,5.4-0.3c3.6-0.2,7.2-0.4,10.8-0.4c3.6,0,7.2,0.6,10.7,0.9 c3.6,0.2,7.2,0,10.7-0.7c-3.5,0.9-7.1,1.3-10.7,1.2c-3.6-0.2-7.1-0.9-10.7-0.8c-3.6-0.1-7.2,0.1-10.8,0.2 c-2.7,0.1-5.4,0.3-8.1-0.1C191.6,467.3,190.7,467,190,466.3L190,466.3z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M137.2,455.4c-1.7-0.7-3.3-2.1-3.1-3.9c0.3-2.8,2.1-8.4,4.9-11.4c3-3.3,4.9,5.3,9.8,6.6 c4.9,1.3,6.8-3.3,10.2,1s7.7,13.7,14.8,13.9c6.3,0.2,5.8,5.7-1.5,6.3C158.7,469.3,137.2,455.4,137.2,455.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M136,450c0.9,1.6,2.1,2.9,3.7,3.6c1.6,0.7,3.1,1.5,4.8,2.1c3.4,1.2,6.4,2.4,9.7,3.9c3.3,1.4,6.3,3.5,9.4,5.2 c3.2,1.6,7.8,2,11.3,1.2c-3.5,0.8-8.2,0.7-11.5-0.8c-3.3-1.6-6.1-3.7-9.5-5c-3.3-1.5-6.2-2.7-9.6-4c-2.5-1-5.6-2.2-7.2-4.1 C136.5,451.3,136.3,450.8,136,450L136,450z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008837680913697647870000013629018105622835125_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.5114,
    y1: 339.3157,
    x2: 157.5159,
    y2: 381.3304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2564D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008837680913697647870000013629018105622835125_)"
    },
    d: "M112.2,376.2l5.3-28l64.8,8.2 c8.2,1,14.7,7.5,15.9,15.7l10.1,73.1l-20.3,3.3l-15.1-65.8L112.2,376.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134231553474042923650000015321821799935947906_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.9687,
    y1: 401.1004,
    x2: 175.6409,
    y2: 402.4342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134231553474042923650000015321821799935947906_)"
    },
    d: "M166.9,337.6l-10.7,125.7 c-0.1,1.7,1.2,3.1,2.8,3.1l0,0c1.4,0,2.6-1,2.8-2.4l20.1-126.3H166.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116943337903184906410000008556259279829030829_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.9594,
    y1: 398.2311,
    x2: 382.6193,
    y2: 400.8987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116943337903184906410000008556259279829030829_)"
    },
    d: "M393,337.6l10.3,121.3 c0.1,1.6-0.9,3-2.3,3h0c-1.1,0-2.1-1-2.2-2.3L381,337.6H393z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127018631064131015610000015482793960303897019_",
    gradientUnits: "userSpaceOnUse",
    x1: -1141.3251,
    y1: 425.59,
    x2: -1125.0692,
    y2: 425.59,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127018631064131015610000015482793960303897019_)"
    },
    d: "M439.8,464.7c0.1,0,0.3,0,0.4,0 c1.6-0.2,2.7-1.7,2.4-3.3l-10.5-72.5c-0.2-1.6-1.7-2.7-3.3-2.4c-1.6,0.2-2.7,1.7-2.4,3.3l10.5,72.5 C437.2,463.7,438.4,464.7,439.8,464.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059988735823190616900000006178198108188628893_",
    gradientUnits: "userSpaceOnUse",
    x1: -1065.0809,
    y1: 425.59,
    x2: -1048.8251,
    y2: 425.59,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059988735823190616900000006178198108188628893_)"
    },
    d: "M353.1,464.7c1.4,0,2.6-1,2.8-2.5 l10.5-72.5c0.2-1.6-0.9-3-2.4-3.3c-1.6-0.2-3,0.9-3.3,2.4l-10.5,72.5c-0.2,1.6,0.9,3,2.4,3.3 C352.8,464.7,352.9,464.7,353.1,464.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078763319086499905380000008427045190355105930_",
    gradientUnits: "userSpaceOnUse",
    x1: -1100.6016,
    y1: 357.7342,
    x2: -1094.0992,
    y2: 387.0778,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078763319086499905380000008427045190355105930_)"
    },
    d: "M370.1,376.2h50.8c5.2,0,9.3,4.2,9.3,9.3 v3.8h-69.5v-3.8C360.8,380.4,364.9,376.2,370.1,376.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067916667356999923430000017624190544933528214_",
    gradientUnits: "userSpaceOnUse",
    x1: -1162.0959,
    y1: 298.7354,
    x2: -1134.0862,
    y2: 362.7578,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067916667356999923430000017624190544933528214_)"
    },
    d: "M435.9,352.8l13.7-48.9 c1.4-5,6.6-7.9,11.5-6.5l3.7,1L446,365.3l-3.7-1C437.3,362.9,434.5,357.7,435.9,352.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021079679608921808810000005169637036147504003_",
    gradientUnits: "userSpaceOnUse",
    x1: -1167.7764,
    y1: 341.3164,
    x2: -1051.4702,
    y2: 341.3164,
    gradientTransform: "matrix(-1 0 0 1 -698.6522 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021079679608921808810000005169637036147504003_)"
    },
    d: "M355.7,392.2h75.8 c5.8,0,11-3.9,12.6-9.5l24.9-88.6c0.4-1.5-0.5-3.1-2-3.5c-1.5-0.4-3.1,0.5-3.5,2l-24.9,88.6c-0.9,3.1-3.8,5.3-7.1,5.3h-75.8 c-1.6,0-2.9,1.3-2.9,2.9S354.1,392.2,355.7,392.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "161.3,245 158.6,254.1 156.4,261.6 135.7,251.5 149.9,230.3 153.8,235.4  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M161.3,245l-3.2,10.7c-4.5-5.7-5.8-14.6-6.6-20.4l4,0.6L161.3,245z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M150.7,217.2l-1.7,7c-1.2,4.8-0.3,9.9,2.6,14l6.9,9.9c2.5,3.5,7.9,3.6,10.5,0.1l3.9-5.3 c1.9-2.6,3.3-5.4,4.2-8.4l3.1-10.6c1.5-5.1-0.6-10.6-5.3-13.6l-3.8-2.4c-3.7-2.4-8.6-2.4-12.4-0.2l-1.2,0.7 C154.1,210.3,151.7,213.5,150.7,217.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023261047828344006010000016589378693392300167_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.8795,
    y1: 212.1962,
    x2: 185.6313,
    y2: 215.5794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023261047828344006010000016589378693392300167_)"
    },
    d: "M155,221.8c13.3,4.8,17.6,3,19.5,0.9 c5.1,3.2,10.9,0.4,12.8-4.8c-0.5-4-8.6-13.9-23.6-13.6c-2.8-4-9.9,0.4-13.1,7C147.2,217.9,151.2,220.4,155,221.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174567202029515486050000001139176809373925298_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.2182,
    y1: 208.9429,
    x2: 141.041,
    y2: 222.2809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174567202029515486050000001139176809373925298_)"
    },
    d: "M148.5,230.3c-4.6-11-2.8-19.5,0.7-24.7 c3.5-5.2,16.2,6.7,13.8,11.9S156.1,233.3,148.5,230.3z"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M156.1,227.9c0,3.8-2.4,6.9-5.3,6.9s-5.3-3.1-5.3-6.9c0-3.8,2.4-6.9,5.3-6.9S156.1,224.1,156.1,227.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060716782362702947610000014033405168393495467_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.7701,
    y1: 401.9838,
    x2: 422.527,
    y2: 401.9838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060716782362702947610000014033405168393495467_)"
    },
    d: "M411.8,337.6l10.7,125.7 c0.1,1.7-1.2,3.1-2.8,3.1l0,0c-1.4,0-2.6-1-2.8-2.4l-20.1-126.3H411.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008135001368232132430000001969145999720012688_",
    cx: 120.1842,
    cy: 279.4489,
    r: 100.8602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008135001368232132430000001969145999720012688_)"
    },
    d: "M157,314.9c-0.5,15-0.4,29,0.8,37.9 c-23.1,24-53.2,23.8-53.2,23.8c-6-34-1.9-110.2,27.4-126.5c8.2-1.8,20.2,3.2,28.2,9.2c-0.2,3.1-0.5,6.7-0.7,10.6 C158.6,282.8,157.5,299.4,157,314.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085958090005944938530000003601628129584578192_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.3211,
    y1: 318.5461,
    x2: 289.3211,
    y2: 329.7303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2564D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085958090005944938530000003601628129584578192_)"
    },
    d: "M421.2,337.6H157.4 c-3.1,0-5.6-2.5-5.6-5.6v-10.1h274.9V332C426.8,335.1,424.3,337.6,421.2,337.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105395598708546722480000004116305317407188108_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.3211,
    y1: 316.5453,
    x2: 289.3211,
    y2: 321.5533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8D3E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105395598708546722480000004116305317407188108_)"
    },
    d: "M434.4,321.9H144.3 c-1.7,0-3.1-1.4-3.1-3.1l0,0c0-1.7,1.4-3.1,3.1-3.1h290.1c1.7,0,3.1,1.4,3.1,3.1l0,0C437.5,320.5,436.1,321.9,434.4,321.9z"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M207.8,305.9c0-0.1,2.2,0.6,4.2,1.2c2,0.6,4.2,0.5,6.2-0.2l0.5-0.2c1.3-0.5,2.8-0.4,4.1,0.1l0.7,0.3 c1.3,0.6,2.4,1.3,3.4,2.3l2.2,2.1c0.8,0.7,1,1.8,0.7,2.8l0,0c-0.3,0.8-1,1.3-1.8,1.3h-18.8c-2.8,0-5.6-0.4-8.3-1.2l-2.5-0.7 l4.3-8.4L207.8,305.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117646547887750234540000012308668209697339556_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.6696,
    y1: 338.4052,
    x2: 207.175,
    y2: 323.1498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117646547887750234540000012308668209697339556_)"
    },
    d: "M252.8,311.9h-71.3c-1.1,0-2,0.9-2,2v1.7 h73.4V311.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148660811400543156280000002437521102633766545_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.9029,
    y1: 318.4534,
    x2: 247.2805,
    y2: 294.8201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148660811400543156280000002437521102633766545_)"
    },
    d: "M279.8,271.5h-52.3c-1.4,0-2.7,1-3,2.3 l-10.7,39c-0.4,1.4,0.7,2.8,2.1,2.8h51.8c1.4,0,2.7-1,3.1-2.3l10.8-39.4C282,272.7,281,271.5,279.8,271.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149345968182541031710000017349249348205527719_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.3664,
    y1: 316.6588,
    x2: 278.3898,
    y2: 277.6451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149345968182541031710000017349249348205527719_)"
    },
    d: "M283.1,271.5h-52.3c-1.4,0-2.7,1-3,2.3 l-10.7,39c-0.4,1.4,0.7,2.8,2.1,2.8h51.8c1.4,0,2.7-1,3.1-2.3l10.8-39.4C285.3,272.7,284.4,271.5,283.1,271.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007422957818134106300000008889877559464802213_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.5718,
    y1: 299.0229,
    x2: 251.7,
    y2: 292.5206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2564D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007422957818134106300000008889877559464802213_)"
    },
    d: "M257.1,293.6c-0.8,3.8-4.6,6.9-8.4,6.9 c-3.8,0-6.3-3.1-5.4-6.9c0.8-3.8,4.6-6.9,8.4-6.9C255.5,286.7,257.9,289.8,257.1,293.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031178859035876973890000009031482203613899942_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.7942,
    y1: 281.2838,
    x2: 145.7949,
    y2: 303.1248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031178859035876973890000009031482203613899942_)"
    },
    d: "M159.5,279.3c-0.9,13-1.9,20.1-2.4,35.6 c-9.1-2.1-15.7-8-15.9-10.6c-0.2-3.3-6.1-9.3-10-12c-3.9-2.8-4.4-27.5-4.4-27.5L159.5,279.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015315574014974012680000014547738027043520162_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9241,
    y1: 292.8591,
    x2: 144.6677,
    y2: 318.118
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015315574014974012680000014547738027043520162_)"
    },
    d: "M156.1,263.8l8.8,27.4l43.3,13.6 l-4.1,10.9l-41.7-3.6c-6.7-0.6-12.8-4-16.8-9.4L127.4,271C122.7,252.7,151.5,245.5,156.1,263.8z"
  }), /*#__PURE__*/React.createElement("g", null, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M290.9,269.3l-4.5,3.8c-0.7,0.6-1.5,1-2.4,1.2l-1.1,0.2c-2.5,0.5-4.7,2.3-5.7,4.7l-0.3,0.7 c-0.7,1.7-0.1,3.6,1.5,4.6l0,0c1.7,1.1,3.7,1.2,5.5,0.4l3.8-1.7c1.3-0.6,2.4-1.3,3.4-2.3l5.8-5.5L290.9,269.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175280837460144170720000016429407375535320473_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.9995,
    y1: 221.7954,
    x2: 342.5289,
    y2: 253.3067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175280837460144170720000016429407375535320473_)"
    },
    d: "M350,212l-15.5,38.3 c-2,5-5.6,9.2-10.3,11.9l-25.7,15l-4.5,2.6l-8.8-8.3l4.6-4.2l24.1-21.6l12.5-43.9L350,212z"
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "306.8,443.1 305.6,459.5 321.1,459.3 322.6,443.1  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "349.6,459.5 348.4,443.1 363.9,443.3 365.4,459.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040555914801665530200000007989346548476810428_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.4169,
    y1: 431.4259,
    x2: 510.5527,
    y2: 332.8914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040555914801665530200000007989346548476810428_)"
    },
    d: "M313.8,301.8h58l1.4,8.6 c1.4,8.5,1.2,17.2-0.6,25.7l-1.1,11.5c-0.5,5.4-0.9,10.8-1,16.2l-1.8,86.2l-23.6,0.6l-2.8-121.1l-17,121.1h-22.5L313.8,301.8z"
  }), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M320.1,470c1.8,0,3.4-1.2,3.9-2.9c0.8-2.8,1.5-7,0.1-10.8c-1.5-4.3-6.6,2.9-11.6,2.3c-5-0.7-5-5.7-9.8-3 c-4.8,2.6-13.9,8-20.9,9c-7,1-4,5.5-0.5,5.5H320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M323,466.3c-1.4,1.2-3.4,1-5.1,1c-1.8,0-3.6-0.2-5.4-0.3c-3.6-0.2-7.2-0.4-10.8-0.4 c-3.6,0-7.2,0.6-10.7,0.9c-3.6,0.2-7.2,0-10.7-0.7c3.5,0.9,7.1,1.3,10.7,1.2c3.6-0.2,7.1-0.9,10.7-0.8c3.6-0.1,7.2,0.1,10.8,0.2 c2.7,0.1,5.4,0.3,8.1-0.1C321.5,467.3,322.4,467,323,466.3L323,466.3z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M363.1,470c1.8,0,3.4-1.2,3.9-2.9c0.8-2.8,1.5-7,0.1-10.8c-1.5-4.3-6.6,2.9-11.6,2.3c-5-0.7-5-5.7-9.8-3 c-4.8,2.6-13.9,8-20.9,9c-7,1-4,5.5-0.5,5.5H363.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M366.1,466.3c-1.4,1.2-3.4,1-5.1,1c-1.8,0-3.6-0.2-5.4-0.3c-3.6-0.2-7.2-0.4-10.8-0.4 c-3.6,0-7.2,0.6-10.7,0.9c-3.6,0.2-7.2,0-10.7-0.7c3.5,0.9,7.1,1.3,10.7,1.2c3.6-0.2,7.1-0.9,10.7-0.8c3.6-0.1,7.2,0.1,10.8,0.2 c2.7,0.1,5.4,0.3,8.1-0.1C364.5,467.3,365.4,467,366.1,466.3L366.1,466.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004546063710611348790000009349604561548859800_",
    gradientUnits: "userSpaceOnUse",
    x1: 490.1736,
    y1: 105.5927,
    x2: 341.1205,
    y2: 259.6476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004546063710611348790000009349604561548859800_)"
    },
    d: "M374.2,301.8c-20.6,6.6-44.5,6.1-62.6,0 c0,0,0.5-2.2,1.3-5.4c0.8-3.5,1.8-8.2,2.6-12.7c0.1-0.5,0.2-1,0.3-1.5c0.9-5.5,2-10.8,2.6-16.7c0.6-5.3,0.7-11.1-0.1-17.8 l-4.5-9.6c-1.5-6.2-0.5-12.7,2.6-18.3l15.1-26.3H350l11.2,4.9c6.6,2.9,11.1,9.2,11.7,16.4l-0.8,23.8c-0.1,4.4-0.4,8.8-0.9,13.1 l-0.3,3.4l-0.5,5l-0.8,8.5c-0.6,5.9-0.5,11.9,0.3,17.7l2.8,9.9L374.2,301.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001645994541248863390000005592714001312414104_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.0246,
    y1: 257.6797,
    x2: 354.0132,
    y2: 280.8011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001645994541248863390000005592714001312414104_)"
    },
    d: "M316.7,275.9l15.4-8.9l28.7-3.7l2.5,4.9 l-36.1,13.5c-2.3,0.9-4.9,0.8-7.2-0.1l0,0l-4.1-1.3L316.7,275.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070101277472152947980000010743941197081681587_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.6581,
    y1: 220.2451,
    x2: 365.5097,
    y2: 241.5527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000070101277472152947980000010743941197081681587_)"
    },
    points: "349.5,254.5 350.5,248.9  341.8,218.6 360.8,216.6 359.8,254.5  "
  }), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M323.6,270.9l-4-1.2l-0.7-0.8c-1.3-1.5-3.4-2.2-5.5-1.8l-6.2,1.2c-1.5,0.3-2.6,1.4-2.7,2.8l-0.1,1.4 c-0.1,1.7,0.9,3.2,2.6,3.9l4,1.2c2,1.1,4.3,1.6,6.6,1.4l5.7-1.7L323.6,270.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051377284664059676470000009599778408958704780_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.0232,
    y1: 180.2212,
    x2: 356.7506,
    y2: 238.4916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#496E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051377284664059676470000009599778408958704780_)"
    },
    d: "M368.1,266.8l-39.4,11.3l-6.2,1.8 l-4-12.3l5.9-2.9l29.6-14.4l-11.2-27.7c-6-14.2,13.6-24.9,23.7-17.1c2.4,1.8,3.9,4.6,4.4,7.6l6.7,38.6 C378.8,258.3,374.7,264.9,368.1,266.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070833706756690569960000013417723718044928655_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.4544,
    y1: 246.7499,
    x2: 363.9385,
    y2: 260.2546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000070833706756690569960000013417723718044928655_)"
    },
    points: "328.7,278.1 322.5,279.9  318.5,267.5 324.4,264.6  "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M319.9,186c0.4,2.2,2,4,4.1,4.7c12.1,3.7,26.7,0.9,34.2-1.3c6.5-1.9,8.6-15.9,6-29.8 c-2.3-12.1-11-18.9-12.8-15.8c-6.1-9.1-25.4-10-30.7,6C316.6,162,318.7,178.9,319.9,186z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112616989960033641960000000923662074547930009_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.5566,
    y1: 301.3518,
    x2: 374.1768,
    y2: 301.3518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112616989960033641960000000923662074547930009_)"
    },
    d: "M374.2,301.8c-20.6,6.6-44.5,6.1-62.6,0 c0,0,0.5-2.2,1.3-5.4c19.7,5.7,39.7,5.5,59.8-0.2L374.2,301.8z"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M350,193.4l-10.9,5.5c-2.2,1.1-4.9,0.2-6-2l-1.8-3.5l0.2-1l3-13l4-1l10.7-2.7L350,193.4z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M347.7,180.8c-2.2,4.5-8.7,9-16.1,11.6l3-13l4-1C342.4,179.4,347.7,180.8,347.7,180.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M338.9,186.9l-3.8,1.2c-3,1-6.3-0.4-7.7-3.2l-2.6-5.2c-1.9-3.8-2.6-8-2.1-12.2l1.1-18.4 c0.1-1.8,1.6-3.1,3.3-3.1h21.7c1.8,0,3.3,1.4,3.3,3.3l0.4,19.1c0,0.4,0,0.8,0,1.2c-0.1,3.3-1.3,6.4-3.3,9.1l-1.2,1.6 C345.8,183.3,342.6,185.6,338.9,186.9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M326.1,157.2c5.4,2,16.8-0.9,18.7-3.3c-2.9,7,1.8,14.7,5.2,16.5c3.4,1.8,5.2-3.9,5.2-3.9s4.3-19.7-3.4-20.2 c-9.7-9.7-20.2-7.2-26.2-0.4S322.4,155.9,326.1,157.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M354.2,173.2c-3.4,7.3-9,7.7-8.1-0.7c0.9-8.5,5.5-8.1,7.6-6.5C355.8,167.5,355.1,171.2,354.2,173.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000213504955325771650000002470515317332672695_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.6075,
    y1: 264.3093,
    x2: 296.9451,
    y2: 281.3153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9F1FD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000213504955325771650000002470515317332672695_)"
    },
    d: "M298.5,277.2l-4.5,2.6l-8.8-8.3l4.6-4.2 C292.9,270.8,296.6,275,298.5,277.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M241.2,212.9h-22.3c-6.4,0-11.5,5.2-11.5,11.5v0c0,4.5,2.5,8.3,6.3,10.2c0,0-0.1,0.1-0.1,0.1 c-1.8,1.9-6.3,2.6-5.5,3.9c0.6,1,6.4,0.3,10.6-1.8c1.2-0.6,2.6-1,3.9-1h18.6c6.4,0,11.5-5.2,11.5-11.5v0 C252.7,218,247.5,212.9,241.2,212.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 219.6,
    cy: 224.9,
    r: 3.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000136397068627991261850000006650762524386395535_",
    cx: 215.4977,
    cy: 221.1934,
    r: 7.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000136397068627991261850000006650762524386395535_)"
    },
    cx: 218.7,
    cy: 224.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 230.9,
    cy: 224.9,
    r: 3.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085961557632296442600000005955489359079476366_",
    cx: 226.7516,
    cy: 221.1934,
    r: 7.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000085961557632296442600000005955489359079476366_)"
    },
    cx: 230,
    cy: 224.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 242.2,
    cy: 224.9,
    r: 3.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000034784464203770665100000008297620879815750016_",
    cx: 238.0056,
    cy: 221.1934,
    r: 7.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000034784464203770665100000008297620879815750016_)"
    },
    cx: 241.2,
    cy: 224.2,
    r: 3.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106833084735598655260000017183119990522371766_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.0766,
    y1: 99.8633,
    x2: 287.8398,
    y2: 154.6325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18CDCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106833084735598655260000017183119990522371766_)"
    },
    d: "M265.5,126.8h22.3 c6.4,0,11.5,5.2,11.5,11.5v0c0,4.5-2.5,8.3-6.3,10.2c0,0,0.1,0.1,0.1,0.1c1.8,1.9,6.3,2.6,5.5,3.9c-0.6,1-6.4,0.3-10.6-1.8 c-1.2-0.6-2.6-1-3.9-1h-18.6c-6.4,0-11.5-5.2-11.5-11.5v0C254,132,259.1,126.8,265.5,126.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st111",
    cx: 287,
    cy: 138.8,
    r: 3.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057137124753047775760000008195761765127512484_",
    cx: -1385.5535,
    cy: 135.1452,
    r: 7.6716,
    gradientTransform: "matrix(-1 0 0 1 -1094.3976 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000057137124753047775760000008195761765127512484_)"
    },
    cx: 287.9,
    cy: 138.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st111",
    cx: 275.8,
    cy: 138.8,
    r: 3.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000096017059575022852480000011005008365157810357_",
    cx: -1374.2996,
    cy: 135.1452,
    r: 7.6716,
    gradientTransform: "matrix(-1 0 0 1 -1094.3976 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000096017059575022852480000011005008365157810357_)"
    },
    cx: 276.7,
    cy: 138.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st111",
    cx: 264.5,
    cy: 138.8,
    r: 3.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000111898281523627990230000004555547063770445502_",
    cx: -1363.0455,
    cy: 135.1452,
    r: 7.6716,
    gradientTransform: "matrix(-1 0 0 1 -1094.3976 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6285,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0D5FD"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000111898281523627990230000004555547063770445502_)"
    },
    cx: 265.4,
    cy: 138.2,
    r: 3.6
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/login_image.7e31e7e0.svg";
export { ForwardRef as ReactComponent };